"use es6";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign$.apply(this, arguments);
};
function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["None"] = 0] = "None";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));

/**
 * @deprecated use ServerZoneType instead
 */
var ServerZone;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
})(ServerZone || (ServerZone = {}));

/** The status of an event. */
var Status;
(function (Status) {
  /** The status could not be determined. */
  Status["Unknown"] = "unknown";
  /** The event was skipped due to configuration or callbacks. */
  Status["Skipped"] = "skipped";
  /** The event was sent successfully. */
  Status["Success"] = "success";
  /** A user or device in the payload is currently rate limited and should try again later. */
  Status["RateLimit"] = "rate_limit";
  /** The sent payload was too large to be processed. */
  Status["PayloadTooLarge"] = "payload_too_large";
  /** The event could not be processed. */
  Status["Invalid"] = "invalid";
  /** A server-side error ocurred during submission. */
  Status["Failed"] = "failed";
  /** a server or client side error occuring when a request takes too long and is cancelled */
  Status["Timeout"] = "Timeout";
  /** NodeJS runtime environment error.. E.g. disconnected from network */
  Status["SystemError"] = "SystemError";
})(Status || (Status = {}));
var AMPLITUDE_PREFIX = 'AMP';
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';
var returnWrapper = function returnWrapper(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};
var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */function () {
  function Logger() {
    this.logLevel = LogLevel.None;
  }
  Logger.prototype.disable = function () {
    this.logLevel = LogLevel.None;
  };
  Logger.prototype.enable = function (logLevel) {
    if (logLevel === void 0) {
      logLevel = LogLevel.Warn;
    }
    this.logLevel = logLevel;
  };
  Logger.prototype.log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Verbose) {
      return;
    }
    console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
  };
  Logger.prototype.warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Warn) {
      return;
    }
    console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
  };
  Logger.prototype.error = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Error) {
      return;
    }
    console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
  };
  Logger.prototype.debug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Debug) {
      return;
    }
    // console.debug output is hidden by default in chrome
    console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
  };
  return Logger;
}();
var getDefaultConfig$1 = function getDefaultConfig$1() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 10000,
    instanceName: '$default_instance',
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: false,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: 'US',
    useBatch: false
  };
};
var Config = /** @class */function () {
  function Config(options) {
    var _a, _b, _c, _d;
    this._optOut = false;
    var defaultConfig = getDefaultConfig$1();
    this.apiKey = options.apiKey;
    this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
    this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
    this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
    this.instanceName = options.instanceName || defaultConfig.instanceName;
    this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
    this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
    this.minIdLength = options.minIdLength;
    this.plan = options.plan;
    this.ingestionMetadata = options.ingestionMetadata;
    this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
    this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
    this.serverUrl = options.serverUrl;
    this.serverZone = options.serverZone || defaultConfig.serverZone;
    this.storageProvider = options.storageProvider;
    this.transportProvider = options.transportProvider;
    this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
    this.loggerProvider.enable(this.logLevel);
    var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
    this.serverZone = serverConfig.serverZone;
    this.serverUrl = serverConfig.serverUrl;
  }
  Object.defineProperty(Config.prototype, "optOut", {
    get: function () {
      return this._optOut;
    },
    set: function (optOut) {
      this._optOut = optOut;
    },
    enumerable: false,
    configurable: true
  });
  return Config;
}();
var getServerUrl$1 = function getServerUrl$1(serverZone, useBatch) {
  if (serverZone === 'EU') {
    return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
  }
  return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
};
var createServerConfig = function createServerConfig(serverUrl, serverZone, useBatch) {
  if (serverUrl === void 0) {
    serverUrl = '';
  }
  if (serverZone === void 0) {
    serverZone = getDefaultConfig$1().serverZone;
  }
  if (useBatch === void 0) {
    useBatch = getDefaultConfig$1().useBatch;
  }
  if (serverUrl) {
    return {
      serverUrl: serverUrl,
      serverZone: undefined
    };
  }
  var _serverZone = ['US', 'EU'].includes(serverZone) ? serverZone : getDefaultConfig$1().serverZone;
  return {
    serverZone: _serverZone,
    serverUrl: getServerUrl$1(_serverZone, useBatch)
  };
};
var getStacktrace = function getStacktrace(ignoreDepth) {
  if (ignoreDepth === void 0) {
    ignoreDepth = 0;
  }
  var trace = new Error().stack || '';
  return trace.split('\n').slice(2 + ignoreDepth).map(function (text) {
    return text.trim();
  });
};
var debugWrapper = function debugWrapper(fn, fnName, getLogConfig, getStates, fnContext) {
  if (fnContext === void 0) {
    fnContext = null;
  }
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _a = getLogConfig(),
      logger = _a.logger,
      logLevel = _a.logLevel;
    // return early if possible to reduce overhead
    if (logLevel && logLevel < LogLevel.Debug || !logLevel || !logger) {
      return fn.apply(fnContext, args);
    }
    var debugContext = {
      type: 'invoke public method',
      name: fnName,
      args: args,
      stacktrace: getStacktrace(1),
      time: {
        start: new Date().toISOString()
      },
      states: {}
    };
    if (getStates && debugContext.states) {
      debugContext.states.before = getStates();
    }
    var result = fn.apply(fnContext, args);
    if (result && result.promise) {
      // if result is a promise, add the callback
      result.promise.then(function () {
        if (getStates && debugContext.states) {
          debugContext.states.after = getStates();
        }
        if (debugContext.time) {
          debugContext.time.end = new Date().toISOString();
        }
        logger.debug(JSON.stringify(debugContext, null, 2));
      });
    } else {
      if (getStates && debugContext.states) {
        debugContext.states.after = getStates();
      }
      if (debugContext.time) {
        debugContext.time.end = new Date().toISOString();
      }
      logger.debug(JSON.stringify(debugContext, null, 2));
    }
    return result;
  };
};

/* eslint-disable @typescript-eslint/no-unsafe-argument */
var BaseTransport = /** @class */function () {
  function BaseTransport() {}
  BaseTransport.prototype.send = function (_serverUrl, _payload) {
    return Promise.resolve(null);
  };
  BaseTransport.prototype.buildResponse = function (responseJSON) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    if (typeof responseJSON !== 'object') {
      return null;
    }
    var statusCode = responseJSON.code || 0;
    var status = this.buildStatus(statusCode);
    switch (status) {
      case Status.Success:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
            payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
            serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
          }
        };
      case Status.Invalid:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
            missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
            eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
            eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
            eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
            epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
            exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
            silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
            silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
            throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
            throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
          }
        };
      case Status.PayloadTooLarge:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
          }
        };
      case Status.RateLimit:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
            epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
            throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
            throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
            exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
            exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
            throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
          }
        };
      case Status.Timeout:
      default:
        return {
          status: status,
          statusCode: statusCode
        };
    }
  };
  BaseTransport.prototype.buildStatus = function (code) {
    if (code >= 200 && code < 300) {
      return Status.Success;
    }
    if (code === 429) {
      return Status.RateLimit;
    }
    if (code === 413) {
      return Status.PayloadTooLarge;
    }
    if (code === 408) {
      return Status.Timeout;
    }
    if (code >= 400 && code < 500) {
      return Status.Invalid;
    }
    if (code >= 500) {
      return Status.Failed;
    }
    return Status.Unknown;
  };
  return BaseTransport;
}();

/* eslint-disable no-restricted-globals */
/* Only file allowed to access to globalThis, window, self */
var getGlobalScope = function getGlobalScope() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  return undefined;
};
var FetchTransport = /** @class */function (_super) {
  __extends(FetchTransport, _super);
  function FetchTransport() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FetchTransport.prototype.send = function (serverUrl, payload) {
    return __awaiter$1(this, void 0, void 0, function () {
      var options, response, responsePayload;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            /* istanbul ignore if */
            if (typeof fetch === 'undefined') {
              throw new Error('FetchTransport is not supported');
            }
            options = {
              headers: {
                'Content-Type': 'application/json',
                Accept: '*/*'
              },
              body: JSON.stringify(payload),
              method: 'POST'
            };
            return [4 /*yield*/, fetch(serverUrl, options)];
          case 1:
            response = _a.sent();
            return [4 /*yield*/, response.json()];
          case 2:
            responsePayload = _a.sent();
            return [2 /*return*/, this.buildResponse(responsePayload)];
        }
      });
    });
  };
  return FetchTransport;
}(BaseTransport);
var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function isEqual(obj1, obj2) {
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
    var p = primitive_1[_i];
    if (p === typeA) {
      return obj1 === obj2;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = _assign({}, this.identity.userProperties);
    var actingIdentity = _assign(_assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var actingProperties = actingIdentity.userProperties || {};
        for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
          var _b = _a[_i],
            action = _b[0],
            properties = _b[1];
          switch (action) {
            case ID_OP_SET:
              for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                var _e = _d[_c],
                  key = _e[0],
                  value = _e[1];
                actingProperties[key] = value;
              }
              break;
            case ID_OP_UNSET:
              for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                var key = _g[_f];
                delete actingProperties[key];
              }
              break;
            case ID_OP_CLEAR_ALL:
              actingProperties = {};
              break;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return _assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = _assign({}, this.identity);
    this.identity = _assign({}, identity);
    if (!isEqual(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();
var getAnalyticsConnector = function getAnalyticsConnector(instanceName) {
  if (instanceName === void 0) {
    instanceName = '$default_instance';
  }
  return AnalyticsConnector.getInstance(instanceName);
};
var DEFAULT_EVENT_PROPERTY_PREFIX = '[Amplitude]';
var DEFAULT_SESSION_REPLAY_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay ID");
var DEFAULT_SAMPLE_RATE = 0;
var DEFAULT_SERVER_ZONE = ServerZone.US;
var SESSION_REPLAY_DEBUG_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay Debug");
var BLOCK_CLASS = 'amp-block';
var MASK_TEXT_CLASS = 'amp-mask';
var UNMASK_TEXT_CLASS = 'amp-unmask';
var SESSION_REPLAY_SERVER_URL = 'https://api-sr.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_EU_URL = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_STAGING_URL = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
var MAX_EVENT_LIST_SIZE_IN_BYTES = 1 * 1000000; // 1 MB
var INTERACTION_MIN_INTERVAL = 30000; // 30 seconds
var INTERACTION_MAX_INTERVAL = 60000; // 1 minute
var MIN_INTERVAL = 500; // 500 ms
var MAX_INTERVAL = 10 * 1000; // 10 seconds

var getDefaultConfig = function getDefaultConfig() {
  return {
    flushMaxRetries: 2,
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    transportProvider: new FetchTransport()
  };
};
var SessionReplayLocalConfig = /** @class */function (_super) {
  __extends(SessionReplayLocalConfig, _super);
  function SessionReplayLocalConfig(apiKey, options) {
    var _this = this;
    var defaultConfig = getDefaultConfig();
    _this = _super.call(this, _assign$(_assign$({
      transportProvider: defaultConfig.transportProvider
    }, options), {
      apiKey: apiKey
    })) || this;
    _this.flushMaxRetries = options.flushMaxRetries !== undefined && options.flushMaxRetries <= defaultConfig.flushMaxRetries ? options.flushMaxRetries : defaultConfig.flushMaxRetries;
    _this.apiKey = apiKey;
    _this.sampleRate = options.sampleRate || DEFAULT_SAMPLE_RATE;
    _this.serverZone = options.serverZone || DEFAULT_SERVER_ZONE;
    _this.configEndpointUrl = options.configEndpointUrl;
    _this.shouldInlineStylesheet = options.shouldInlineStylesheet;
    if (options.privacyConfig) {
      _this.privacyConfig = options.privacyConfig;
    }
    if (options.debugMode) {
      _this.debugMode = options.debugMode;
    }
    return _this;
  }
  return SessionReplayLocalConfig;
}(Config);
var NodeType$1;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));
function isElement(n) {
  return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
  const host = n === null || n === void 0 ? void 0 : n.host;
  return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n);
}
function isNativeShadowDom(shadowRoot) {
  return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
  if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) {
    cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
  }
  return cssText;
}
function escapeImportStatement(rule) {
  const {
    cssText
  } = rule;
  if (cssText.split('"').length < 3) return cssText;
  const statement = ['@import', `url(${JSON.stringify(rule.href)})`];
  if (rule.layerName === '') {
    statement.push(`layer`);
  } else if (rule.layerName) {
    statement.push(`layer(${rule.layerName})`);
  }
  if (rule.supportsText) {
    statement.push(`supports(${rule.supportsText})`);
  }
  if (rule.media.length) {
    statement.push(rule.media.mediaText);
  }
  return statement.join(' ') + ';';
}
function stringifyStylesheet(s) {
  try {
    const rules = s.rules || s.cssRules;
    return rules ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join('')) : null;
  } catch (error) {
    return null;
  }
}
function stringifyRule(rule) {
  let importStringified;
  if (isCSSImportRule(rule)) {
    try {
      importStringified = stringifyStylesheet(rule.styleSheet) || escapeImportStatement(rule);
    } catch (error) {}
  } else if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
    return fixSafariColons(rule.cssText);
  }
  return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
  const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return cssStringified.replace(regex, '$1\\$2');
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}
class Mirror {
  constructor() {
    this.idNodeMap = new Map();
    this.nodeMetaMap = new WeakMap();
  }
  getId(n) {
    var _a;
    if (!n) return -1;
    const id = (_a = this.getMeta(n)) === null || _a === void 0 ? void 0 : _a.id;
    return id !== null && id !== void 0 ? id : -1;
  }
  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(n) {
    return this.nodeMetaMap.get(n) || null;
  }
  removeNodeFromMap(n) {
    const id = this.getId(n);
    this.idNodeMap.delete(id);
    if (n.childNodes) {
      n.childNodes.forEach(childNode => this.removeNodeFromMap(childNode));
    }
  }
  has(id) {
    return this.idNodeMap.has(id);
  }
  hasNode(node) {
    return this.nodeMetaMap.has(node);
  }
  add(n, meta) {
    const id = meta.id;
    this.idNodeMap.set(id, n);
    this.nodeMetaMap.set(n, meta);
  }
  replace(id, n) {
    const oldNode = this.getNode(id);
    if (oldNode) {
      const meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n, meta);
    }
    this.idNodeMap.set(id, n);
  }
  reset() {
    this.idNodeMap = new Map();
    this.nodeMetaMap = new WeakMap();
  }
}
function createMirror() {
  return new Mirror();
}
function maskInputValue({
  element,
  maskInputOptions,
  tagName,
  type,
  value,
  maskInputFn
}) {
  let text = value || '';
  const actualType = type && toLowerCase$1(type);
  if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
    if (maskInputFn) {
      text = maskInputFn(text, element);
    } else {
      text = '*'.repeat(text.length);
    }
  }
  return text;
}
function toLowerCase$1(str) {
  return str.toLowerCase();
}
const ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return true;
  const chunkSize = 50;
  for (let x = 0; x < canvas.width; x += chunkSize) {
    for (let y = 0; y < canvas.height; y += chunkSize) {
      const getImageData = ctx.getImageData;
      const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
      const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
      if (pixelBuffer.some(pixel => pixel !== 0)) return false;
    }
  }
  return true;
}
function getInputType$1(element) {
  const type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ? toLowerCase$1(type) : null;
}
let _id = 1;
const tagNameRegex = new RegExp('[^a-z0-9-_:]');
const IGNORED_NODE = -2;
function genId() {
  return _id++;
}
function getValidTagName(element) {
  if (element instanceof HTMLFormElement) {
    return 'form';
  }
  const processedTagName = toLowerCase$1(element.tagName);
  if (tagNameRegex.test(processedTagName)) {
    return 'div';
  }
  return processedTagName;
}
function extractOrigin(url) {
  let origin = '';
  if (url.indexOf('//') > -1) {
    origin = url.split('/').slice(0, 3).join('/');
  } else {
    origin = url.split('/')[0];
  }
  origin = origin.split('?')[0];
  return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
  return (cssText || '').replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
    const filePath = path1 || path2 || path3;
    const maybeQuote = quote1 || quote2 || '';
    if (!filePath) {
      return origin;
    }
    if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
      return `url(${maybeQuote}${filePath}${maybeQuote})`;
    }
    if (DATA_URI.test(filePath)) {
      return `url(${maybeQuote}${filePath}${maybeQuote})`;
    }
    if (filePath[0] === '/') {
      return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
    }
    const stack = href.split('/');
    const parts = filePath.split('/');
    stack.pop();
    for (const part of parts) {
      if (part === '.') {
        continue;
      } else if (part === '..') {
        stack.pop();
      } else {
        stack.push(part);
      }
    }
    return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
  });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
  if (attributeValue.trim() === '') {
    return attributeValue;
  }
  let pos = 0;
  function collectCharacters(regEx) {
    let chars;
    const match = regEx.exec(attributeValue.substring(pos));
    if (match) {
      chars = match[0];
      pos += chars.length;
      return chars;
    }
    return '';
  }
  const output = [];
  while (true) {
    collectCharacters(SRCSET_COMMAS_OR_SPACES);
    if (pos >= attributeValue.length) {
      break;
    }
    let url = collectCharacters(SRCSET_NOT_SPACES);
    if (url.slice(-1) === ',') {
      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
      output.push(url);
    } else {
      let descriptorsStr = '';
      url = absoluteToDoc(doc, url);
      let inParens = false;
      while (true) {
        const c = attributeValue.charAt(pos);
        if (c === '') {
          output.push((url + descriptorsStr).trim());
          break;
        } else if (!inParens) {
          if (c === ',') {
            pos += 1;
            output.push((url + descriptorsStr).trim());
            break;
          } else if (c === '(') {
            inParens = true;
          }
        } else {
          if (c === ')') {
            inParens = false;
          }
        }
        descriptorsStr += c;
        pos += 1;
      }
    }
  }
  return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
  if (!attributeValue || attributeValue.trim() === '') {
    return attributeValue;
  }
  const a = doc.createElement('a');
  a.href = attributeValue;
  return a.href;
}
function isSVGElement(el) {
  return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
  const a = document.createElement('a');
  a.href = '';
  return a.href;
}
function transformAttribute(doc, tagName, name, value) {
  if (!value) {
    return value;
  }
  if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'xlink:href' && value[0] !== '#') {
    return absoluteToDoc(doc, value);
  } else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
    return absoluteToDoc(doc, value);
  } else if (name === 'srcset') {
    return getAbsoluteSrcsetString(doc, value);
  } else if (name === 'style') {
    return absoluteToStylesheet(value, getHref());
  } else if (tagName === 'object' && name === 'data') {
    return absoluteToDoc(doc, value);
  }
  return value;
}
function ignoreAttribute(tagName, name, _value) {
  return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function _isBlockedElement(element, blockClass, blockSelector) {
  try {
    if (typeof blockClass === 'string') {
      if (element.classList.contains(blockClass)) {
        return true;
      }
    } else {
      for (let eIndex = element.classList.length; eIndex--;) {
        const className = element.classList[eIndex];
        if (blockClass.test(className)) {
          return true;
        }
      }
    }
    if (blockSelector) {
      return element.matches(blockSelector);
    }
  } catch (e) {}
  return false;
}
function classMatchesRegex(node, regex, checkAncestors) {
  if (!node) return false;
  if (node.nodeType !== node.ELEMENT_NODE) {
    if (!checkAncestors) return false;
    return classMatchesRegex(node.parentNode, regex, checkAncestors);
  }
  for (let eIndex = node.classList.length; eIndex--;) {
    const className = node.classList[eIndex];
    if (regex.test(className)) {
      return true;
    }
  }
  if (!checkAncestors) return false;
  return classMatchesRegex(node.parentNode, regex, checkAncestors);
}
function needMaskingText(node, maskTextClass, maskTextSelector) {
  try {
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (el === null) return false;
    if (typeof maskTextClass === 'string') {
      if (el.classList.contains(maskTextClass)) return true;
      if (el.closest(`.${maskTextClass}`)) return true;
    } else {
      if (classMatchesRegex(el, maskTextClass, true)) return true;
    }
    if (maskTextSelector) {
      if (el.matches(maskTextSelector)) return true;
      if (el.closest(maskTextSelector)) return true;
    }
  } catch (e) {}
  return false;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
  const win = iframeEl.contentWindow;
  if (!win) {
    return;
  }
  let fired = false;
  let readyState;
  try {
    readyState = win.document.readyState;
  } catch (error) {
    return;
  }
  if (readyState !== 'complete') {
    const timer = setTimeout(() => {
      if (!fired) {
        listener();
        fired = true;
      }
    }, iframeLoadTimeout);
    iframeEl.addEventListener('load', () => {
      clearTimeout(timer);
      fired = true;
      listener();
    });
    return;
  }
  const blankUrl = 'about:blank';
  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
    setTimeout(listener, 0);
    return iframeEl.addEventListener('load', listener);
  }
  iframeEl.addEventListener('load', listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
  let fired = false;
  let styleSheetLoaded;
  try {
    styleSheetLoaded = link.sheet;
  } catch (error) {
    return;
  }
  if (styleSheetLoaded) return;
  const timer = setTimeout(() => {
    if (!fired) {
      listener();
      fired = true;
    }
  }, styleSheetLoadTimeout);
  link.addEventListener('load', () => {
    clearTimeout(timer);
    fired = true;
    listener();
  });
}
function serializeNode(n, options) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false
  } = options;
  const rootId = getRootId(doc, mirror);
  switch (n.nodeType) {
    case n.DOCUMENT_NODE:
      if (n.compatMode !== 'CSS1Compat') {
        return {
          type: NodeType$1.Document,
          childNodes: [],
          compatMode: n.compatMode
        };
      } else {
        return {
          type: NodeType$1.Document,
          childNodes: []
        };
      }
    case n.DOCUMENT_TYPE_NODE:
      return {
        type: NodeType$1.DocumentType,
        name: n.name,
        publicId: n.publicId,
        systemId: n.systemId,
        rootId
      };
    case n.ELEMENT_NODE:
      return serializeElementNode(n, {
        doc,
        blockClass,
        blockSelector,
        inlineStylesheet,
        maskInputOptions,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement,
        rootId
      });
    case n.TEXT_NODE:
      return serializeTextNode(n, {
        maskTextClass,
        maskTextSelector,
        maskTextFn,
        rootId
      });
    case n.CDATA_SECTION_NODE:
      return {
        type: NodeType$1.CDATA,
        textContent: '',
        rootId
      };
    case n.COMMENT_NODE:
      return {
        type: NodeType$1.Comment,
        textContent: n.textContent || '',
        rootId
      };
    default:
      return false;
  }
}
function getRootId(doc, mirror) {
  if (!mirror.hasNode(doc)) return undefined;
  const docId = mirror.getId(doc);
  return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
  var _a;
  const {
    maskTextClass,
    maskTextSelector,
    maskTextFn,
    rootId
  } = options;
  const parentTagName = n.parentNode && n.parentNode.tagName;
  let textContent = n.textContent;
  const isStyle = parentTagName === 'STYLE' ? true : undefined;
  const isScript = parentTagName === 'SCRIPT' ? true : undefined;
  if (isStyle && textContent) {
    try {
      if (n.nextSibling || n.previousSibling) {} else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) {
        textContent = stringifyStylesheet(n.parentNode.sheet);
      }
    } catch (err) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
    }
    textContent = absoluteToStylesheet(textContent, getHref());
  }
  if (isScript) {
    textContent = 'SCRIPT_PLACEHOLDER';
  }
  if (!isStyle && !isScript && textContent && needMaskingText(n, maskTextClass, maskTextSelector)) {
    textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
  }
  return {
    type: NodeType$1.Text,
    textContent: textContent || '',
    isStyle,
    rootId
  };
}
function serializeElementNode(n, options) {
  const {
    doc,
    blockClass,
    blockSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    rootId
  } = options;
  const needBlock = _isBlockedElement(n, blockClass, blockSelector);
  const tagName = getValidTagName(n);
  let attributes = {};
  const len = n.attributes.length;
  for (let i = 0; i < len; i++) {
    const attr = n.attributes[i];
    if (!ignoreAttribute(tagName, attr.name, attr.value)) {
      attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase$1(attr.name), attr.value);
    }
  }
  if (tagName === 'link' && inlineStylesheet) {
    const stylesheet = Array.from(doc.styleSheets).find(s => {
      return s.href === n.href;
    });
    let cssText = null;
    if (stylesheet) {
      cssText = stringifyStylesheet(stylesheet);
    }
    if (cssText) {
      delete attributes.rel;
      delete attributes.href;
      attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
    }
  }
  if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
    const cssText = stringifyStylesheet(n.sheet);
    if (cssText) {
      attributes._cssText = absoluteToStylesheet(cssText, getHref());
    }
  }
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
    const value = n.value;
    const checked = n.checked;
    if (attributes.type !== 'radio' && attributes.type !== 'checkbox' && attributes.type !== 'submit' && attributes.type !== 'button' && value) {
      const type = getInputType$1(n);
      attributes.value = maskInputValue({
        element: n,
        type,
        tagName,
        value,
        maskInputOptions,
        maskInputFn
      });
    } else if (checked) {
      attributes.checked = checked;
    }
  }
  if (tagName === 'option') {
    if (n.selected && !maskInputOptions['select']) {
      attributes.selected = true;
    } else {
      delete attributes.selected;
    }
  }
  if (tagName === 'canvas' && recordCanvas) {
    if (n.__context === '2d') {
      if (!is2DCanvasBlank(n)) {
        attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      }
    } else if (!('__context' in n)) {
      const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      const blankCanvas = document.createElement('canvas');
      blankCanvas.width = n.width;
      blankCanvas.height = n.height;
      const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      if (canvasDataURL !== blankCanvasDataURL) {
        attributes.rr_dataURL = canvasDataURL;
      }
    }
  }
  if (tagName === 'img' && inlineImages) {
    if (!canvasService) {
      canvasService = doc.createElement('canvas');
      canvasCtx = canvasService.getContext('2d');
    }
    const image = n;
    const oldValue = image.crossOrigin;
    image.crossOrigin = 'anonymous';
    const recordInlineImage = () => {
      image.removeEventListener('load', recordInlineImage);
      try {
        canvasService.width = image.naturalWidth;
        canvasService.height = image.naturalHeight;
        canvasCtx.drawImage(image, 0, 0);
        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      } catch (err) {
        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
      }
      oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
    };
    if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener('load', recordInlineImage);
  }
  if (tagName === 'audio' || tagName === 'video') {
    attributes.rr_mediaState = n.paused ? 'paused' : 'played';
    attributes.rr_mediaCurrentTime = n.currentTime;
  }
  if (!newlyAddedElement) {
    if (n.scrollLeft) {
      attributes.rr_scrollLeft = n.scrollLeft;
    }
    if (n.scrollTop) {
      attributes.rr_scrollTop = n.scrollTop;
    }
  }
  if (needBlock) {
    const {
      width,
      height
    } = n.getBoundingClientRect();
    attributes = {
      class: attributes.class,
      rr_width: `${width}px`,
      rr_height: `${height}px`
    };
  }
  if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
    if (!n.contentDocument) {
      attributes.rr_src = attributes.src;
    }
    delete attributes.src;
  }
  return {
    type: NodeType$1.Element,
    tagName,
    attributes,
    childNodes: [],
    isSVG: isSVGElement(n) || undefined,
    needBlock,
    rootId
  };
}
function lowerIfExists(maybeAttr) {
  if (maybeAttr === undefined || maybeAttr === null) {
    return '';
  } else {
    return maybeAttr.toLowerCase();
  }
}
function slimDOMExcluded(sn, slimDOMOptions) {
  if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
    return true;
  } else if (sn.type === NodeType$1.Element) {
    if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) {
      return true;
    } else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === 'application-name' || lowerIfExists(sn.attributes.rel) === 'icon' || lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) {
      return true;
    } else if (sn.tagName === 'meta') {
      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
        return true;
      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === 'pinterest')) {
        return true;
      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === 'robots' || lowerIfExists(sn.attributes.name) === 'googlebot' || lowerIfExists(sn.attributes.name) === 'bingbot')) {
        return true;
      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) {
        return true;
      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === 'author' || lowerIfExists(sn.attributes.name) === 'generator' || lowerIfExists(sn.attributes.name) === 'framework' || lowerIfExists(sn.attributes.name) === 'publisher' || lowerIfExists(sn.attributes.name) === 'progid' || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
        return true;
      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === 'google-site-verification' || lowerIfExists(sn.attributes.name) === 'yandex-verification' || lowerIfExists(sn.attributes.name) === 'csrf-token' || lowerIfExists(sn.attributes.name) === 'p:domain_verify' || lowerIfExists(sn.attributes.name) === 'verify-v1' || lowerIfExists(sn.attributes.name) === 'verification' || lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
        return true;
      }
    }
  }
  return false;
}
function serializeNodeWithId(n, options) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    skipChild = false,
    inlineStylesheet = true,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions = {},
    inlineImages = false,
    recordCanvas = false,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout = 5000,
    onStylesheetLoad,
    stylesheetLoadTimeout = 5000,
    keepIframeSrcFn = () => false,
    newlyAddedElement = false
  } = options;
  let {
    preserveWhiteSpace = true
  } = options;
  const _serializedNode = serializeNode(n, {
    doc,
    mirror,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    inlineStylesheet,
    maskInputOptions,
    maskTextFn,
    maskInputFn,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement
  });
  if (!_serializedNode) {
    console.warn(n, 'not serialized');
    return null;
  }
  let id;
  if (mirror.hasNode(n)) {
    id = mirror.getId(n);
  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) {
    id = IGNORED_NODE;
  } else {
    id = genId();
  }
  const serializedNode = Object.assign(_serializedNode, {
    id
  });
  mirror.add(n, serializedNode);
  if (id === IGNORED_NODE) {
    return null;
  }
  if (onSerialize) {
    onSerialize(n);
  }
  let recordChild = !skipChild;
  if (serializedNode.type === NodeType$1.Element) {
    recordChild = recordChild && !serializedNode.needBlock;
    delete serializedNode.needBlock;
    const shadowRoot = n.shadowRoot;
    if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
  }
  if ((serializedNode.type === NodeType$1.Document || serializedNode.type === NodeType$1.Element) && recordChild) {
    if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'head') {
      preserveWhiteSpace = false;
    }
    const bypassOptions = {
      doc,
      mirror,
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      skipChild,
      inlineStylesheet,
      maskInputOptions,
      maskTextFn,
      maskInputFn,
      slimDOMOptions,
      dataURLOptions,
      inlineImages,
      recordCanvas,
      preserveWhiteSpace,
      onSerialize,
      onIframeLoad,
      iframeLoadTimeout,
      onStylesheetLoad,
      stylesheetLoadTimeout,
      keepIframeSrcFn
    };
    for (const childN of Array.from(n.childNodes)) {
      const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
      if (serializedChildNode) {
        serializedNode.childNodes.push(serializedChildNode);
      }
    }
    if (isElement(n) && n.shadowRoot) {
      for (const childN of Array.from(n.shadowRoot.childNodes)) {
        const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
        if (serializedChildNode) {
          isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
          serializedNode.childNodes.push(serializedChildNode);
        }
      }
    }
  }
  if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) {
    serializedNode.isShadow = true;
  }
  if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'iframe') {
    onceIframeLoaded(n, () => {
      const iframeDoc = n.contentDocument;
      if (iframeDoc && onIframeLoad) {
        const serializedIframeNode = serializeNodeWithId(iframeDoc, {
          doc: iframeDoc,
          mirror,
          blockClass,
          blockSelector,
          maskTextClass,
          maskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });
        if (serializedIframeNode) {
          onIframeLoad(n, serializedIframeNode);
        }
      }
    }, iframeLoadTimeout);
  }
  if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') {
    onceStylesheetLoaded(n, () => {
      if (onStylesheetLoad) {
        const serializedLinkNode = serializeNodeWithId(n, {
          doc,
          mirror,
          blockClass,
          blockSelector,
          maskTextClass,
          maskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });
        if (serializedLinkNode) {
          onStylesheetLoad(n, serializedLinkNode);
        }
      }
    }, stylesheetLoadTimeout);
  }
  return serializedNode;
}
function snapshot(n, options) {
  const {
    mirror = new Mirror(),
    blockClass = 'rr-block',
    blockSelector = null,
    maskTextClass = 'rr-mask',
    maskTextSelector = null,
    inlineStylesheet = true,
    inlineImages = false,
    recordCanvas = false,
    maskAllInputs = false,
    maskTextFn,
    maskInputFn,
    slimDOM = false,
    dataURLOptions,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn = () => false
  } = options || {};
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    password: true
  } : maskAllInputs === false ? {
    password: true
  } : maskAllInputs;
  const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaDescKeywords: slimDOM === 'all',
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaAuthorship: true,
    headMetaVerification: true
  } : slimDOM === false ? {} : slimDOM;
  return serializeNodeWithId(n, {
    doc: n,
    mirror,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    skipChild: false,
    inlineStylesheet,
    maskInputOptions,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn,
    newlyAddedElement: false
  });
}
var EventType = /* @__PURE__ */(EventType2 => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */(IncrementalSource2 => {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions$1 = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions$1 || {});
var PointerTypes = /* @__PURE__ */(PointerTypes2 => {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
})(PointerTypes || {});
var CanvasContext = /* @__PURE__ */(CanvasContext2 => {
  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
  return CanvasContext2;
})(CanvasContext || {});
function on(type, fn, target = document) {
  const options = {
    capture: true,
    passive: true
  };
  target.addEventListener(type, fn, options);
  return () => target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
let _mirror = {
  map: {},
  getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function throttle(func, wait, options = {}) {
  let timeout = null;
  let previous = 0;
  return function (...args) {
    const now = Date.now();
    if (!previous && options.leading === false) {
      previous = now;
    }
    const remaining = wait - (now - previous);
    const context = this;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(() => {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}
function hookSetter(target, key, d, isRevoked, win = window) {
  const original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set(value) {
      setTimeout(() => {
        d.set.call(this, value);
      }, 0);
      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return () => {};
    }
    const original = source[name];
    const wrapped = replacement(original);
    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }
    source[name] = wrapped;
    return () => {
      source[name] = original;
    };
  } catch (_a) {
    return () => {};
  }
}
let nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = () => new Date().getTime();
}
function getWindowScroll(win) {
  var _a, _b, _c, _d, _e, _f;
  const doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || ((_b = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || ((_c = doc === null || doc === void 0 ? void 0 : doc.body) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || ((_e = (_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.scrollTop) || ((_f = doc === null || doc === void 0 ? void 0 : doc.body) === null || _f === void 0 ? void 0 : _f.scrollTop) || 0
  };
}
function getWindowHeight$1() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth$1() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node) {
  if (!node) {
    return null;
  }
  const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  return el;
}
function isBlocked(node, blockClass, blockSelector, checkAncestors) {
  if (!node) {
    return false;
  }
  const el = closestElementOfNode(node);
  if (!el) {
    return false;
  }
  try {
    if (typeof blockClass === 'string') {
      if (el.classList.contains(blockClass)) return true;
      if (checkAncestors && el.closest('.' + blockClass) !== null) return true;
    } else {
      if (classMatchesRegex(el, blockClass, checkAncestors)) return true;
    }
  } catch (e) {}
  if (blockSelector) {
    if (el.matches(blockSelector)) return true;
    if (checkAncestors && el.closest(blockSelector) !== null) return true;
  }
  return false;
}
function isSerialized(n, mirror) {
  return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
  return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
  if (isShadowRoot(target)) {
    return false;
  }
  const id = mirror.getId(target);
  if (!mirror.has(id)) {
    return true;
  }
  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
    return false;
  }
  if (!target.parentNode) {
    return true;
  }
  return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function polyfill(win = window) {
  if ('NodeList' in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }
  if (!Node.prototype.contains) {
    Node.prototype.contains = (...args) => {
      let node = args[0];
      if (!(0 in args)) {
        throw new TypeError('1 argument is required');
      }
      do {
        if (this === node) {
          return true;
        }
      } while (node = node && node.parentNode);
      return false;
    };
  }
}
function isSerializedIframe(n, mirror) {
  return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
  return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function hasShadowRoot(n) {
  return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
class StyleSheetMirror {
  constructor() {
    this.id = 1;
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
  }
  getId(stylesheet) {
    var _a;
    return (_a = this.styleIDMap.get(stylesheet)) !== null && _a !== void 0 ? _a : -1;
  }
  has(stylesheet) {
    return this.styleIDMap.has(stylesheet);
  }
  add(stylesheet, id) {
    if (this.has(stylesheet)) return this.getId(stylesheet);
    let newId;
    if (id === undefined) {
      newId = this.id++;
    } else newId = id;
    this.styleIDMap.set(stylesheet, newId);
    this.idStyleMap.set(newId, stylesheet);
    return newId;
  }
  getStyle(id) {
    return this.idStyleMap.get(id) || null;
  }
  reset() {
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
    this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function getShadowHost(n) {
  var _a, _b;
  let shadowHost = null;
  if (((_b = (_a = n.getRootNode) === null || _a === void 0 ? void 0 : _a.call(n)) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
  return shadowHost;
}
function getRootShadowHost(n) {
  let rootShadowHost = n;
  let shadowHost;
  while (shadowHost = getShadowHost(rootShadowHost)) rootShadowHost = shadowHost;
  return rootShadowHost;
}
function shadowHostInDom(n) {
  const doc = n.ownerDocument;
  if (!doc) return false;
  const shadowHost = getRootShadowHost(n);
  return doc.contains(shadowHost);
}
function inDom(n) {
  const doc = n.ownerDocument;
  if (!doc) return false;
  return doc.contains(n) || shadowHostInDom(n);
}
let errorHandler;
function registerErrorHandler(handler) {
  errorHandler = handler;
}
function unregisterErrorHandler() {
  errorHandler = undefined;
}
const callbackWrapper = cb => {
  if (!errorHandler) {
    return cb;
  }
  const rrwebWrapped = (...rest) => {
    try {
      return cb(...rest);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return;
      }
      throw error;
    }
  };
  return rrwebWrapped;
};
function externalFunctionWrapper(func) {
  return (...args) => {
    try {
      return func(...args);
    } catch (error) {
      try {
        error._external_ = true;
      } catch (_a) {}
      throw error;
    }
  };
}
class CrossOriginIframeMirror {
  constructor(generateIdFn) {
    this.generateIdFn = generateIdFn;
    this.iframeIdToRemoteIdMap = new WeakMap();
    this.iframeRemoteIdToIdMap = new WeakMap();
  }
  getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
    const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
    let id = idToRemoteIdMap.get(remoteId);
    if (!id) {
      id = this.generateIdFn();
      idToRemoteIdMap.set(remoteId, id);
      remoteIdToIdMap.set(id, remoteId);
    }
    return id;
  }
  getIds(iframe, remoteId) {
    const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return remoteId.map(id => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
  }
  getRemoteId(iframe, id, map) {
    const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
    if (typeof id !== 'number') return id;
    const remoteId = remoteIdToIdMap.get(id);
    if (!remoteId) return -1;
    return remoteId;
  }
  getRemoteIds(iframe, ids) {
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return ids.map(id => this.getRemoteId(iframe, id, remoteIdToIdMap));
  }
  reset(iframe) {
    if (!iframe) {
      this.iframeIdToRemoteIdMap = new WeakMap();
      this.iframeRemoteIdToIdMap = new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(iframe);
    this.iframeRemoteIdToIdMap.delete(iframe);
  }
  getIdToRemoteIdMap(iframe) {
    let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
    if (!idToRemoteIdMap) {
      idToRemoteIdMap = new Map();
      this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
    }
    return idToRemoteIdMap;
  }
  getRemoteIdToIdMap(iframe) {
    let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
    if (!remoteIdToIdMap) {
      remoteIdToIdMap = new Map();
      this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
    }
    return remoteIdToIdMap;
  }
}
class IframeManager {
  constructor(options) {
    this.iframes = new WeakMap();
    this.crossOriginIframeMap = new WeakMap();
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
    this.mirror = options.mirror;
    if (this.recordCrossOriginIframes) {
      window.addEventListener('message', this.handleMessage.bind(this));
    }
  }
  addIframe(iframeEl) {
    this.iframes.set(iframeEl, true);
    if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
  }
  addLoadListener(cb) {
    this.loadListener = cb;
  }
  attachIframe(iframeEl, childSn) {
    var _a;
    this.mutationCb({
      adds: [{
        parentId: this.mirror.getId(iframeEl),
        nextId: null,
        node: childSn
      }],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: true
    });
    (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
    if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
  }
  handleMessage(message) {
    const crossOriginMessageEvent = message;
    if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
    const iframeSourceWindow = message.source;
    if (!iframeSourceWindow) return;
    const iframeEl = this.crossOriginIframeMap.get(message.source);
    if (!iframeEl) return;
    const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
    if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
  }
  transformCrossOriginEvent(iframeEl, e) {
    var _a;
    switch (e.type) {
      case EventType.FullSnapshot:
        {
          this.crossOriginIframeMirror.reset(iframeEl);
          this.crossOriginIframeStyleMirror.reset(iframeEl);
          this.replaceIdOnNode(e.data.node, iframeEl);
          const rootId = e.data.node.id;
          this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
          this.patchRootIdOnNode(e.data.node, rootId);
          return {
            timestamp: e.timestamp,
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Mutation,
              adds: [{
                parentId: this.mirror.getId(iframeEl),
                nextId: null,
                node: e.data.node
              }],
              removes: [],
              texts: [],
              attributes: [],
              isAttachIframe: true
            }
          };
        }
      case EventType.Meta:
      case EventType.Load:
      case EventType.DomContentLoaded:
        {
          return false;
        }
      case EventType.Plugin:
        {
          return e;
        }
      case EventType.Custom:
        {
          this.replaceIds(e.data.payload, iframeEl, ['id', 'parentId', 'previousId', 'nextId']);
          return e;
        }
      case EventType.IncrementalSnapshot:
        {
          switch (e.data.source) {
            case IncrementalSource.Mutation:
              {
                e.data.adds.forEach(n => {
                  this.replaceIds(n, iframeEl, ['parentId', 'nextId', 'previousId']);
                  this.replaceIdOnNode(n.node, iframeEl);
                  const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                  rootId && this.patchRootIdOnNode(n.node, rootId);
                });
                e.data.removes.forEach(n => {
                  this.replaceIds(n, iframeEl, ['parentId', 'id']);
                });
                e.data.attributes.forEach(n => {
                  this.replaceIds(n, iframeEl, ['id']);
                });
                e.data.texts.forEach(n => {
                  this.replaceIds(n, iframeEl, ['id']);
                });
                return e;
              }
            case IncrementalSource.Drag:
            case IncrementalSource.TouchMove:
            case IncrementalSource.MouseMove:
              {
                e.data.positions.forEach(p => {
                  this.replaceIds(p, iframeEl, ['id']);
                });
                return e;
              }
            case IncrementalSource.ViewportResize:
              {
                return false;
              }
            case IncrementalSource.MediaInteraction:
            case IncrementalSource.MouseInteraction:
            case IncrementalSource.Scroll:
            case IncrementalSource.CanvasMutation:
            case IncrementalSource.Input:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                return e;
              }
            case IncrementalSource.StyleSheetRule:
            case IncrementalSource.StyleDeclaration:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                this.replaceStyleIds(e.data, iframeEl, ['styleId']);
                return e;
              }
            case IncrementalSource.Font:
              {
                return e;
              }
            case IncrementalSource.Selection:
              {
                e.data.ranges.forEach(range => {
                  this.replaceIds(range, iframeEl, ['start', 'end']);
                });
                return e;
              }
            case IncrementalSource.AdoptedStyleSheet:
              {
                this.replaceIds(e.data, iframeEl, ['id']);
                this.replaceStyleIds(e.data, iframeEl, ['styleIds']);
                (_a = e.data.styles) === null || _a === void 0 ? void 0 : _a.forEach(style => {
                  this.replaceStyleIds(style, iframeEl, ['styleId']);
                });
                return e;
              }
          }
        }
    }
  }
  replace(iframeMirror, obj, iframeEl, keys) {
    for (const key of keys) {
      if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
      if (Array.isArray(obj[key])) {
        obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
      } else {
        obj[key] = iframeMirror.getId(iframeEl, obj[key]);
      }
    }
    return obj;
  }
  replaceIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
  }
  replaceStyleIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
  }
  replaceIdOnNode(node, iframeEl) {
    this.replaceIds(node, iframeEl, ['id', 'rootId']);
    if ('childNodes' in node) {
      node.childNodes.forEach(child => {
        this.replaceIdOnNode(child, iframeEl);
      });
    }
  }
  patchRootIdOnNode(node, rootId) {
    if (node.type !== NodeType$1.Document && !node.rootId) node.rootId = rootId;
    if ('childNodes' in node) {
      node.childNodes.forEach(child => {
        this.patchRootIdOnNode(child, rootId);
      });
    }
  }
}
function isNodeInLinkedList(n) {
  return '__ln' in n;
}
class DoubleLinkedList {
  constructor() {
    this.length = 0;
    this.head = null;
    this.tail = null;
  }
  get(position) {
    if (position >= this.length) {
      throw new Error('Position outside of list range');
    }
    let current = this.head;
    for (let index = 0; index < position; index++) {
      current = (current === null || current === void 0 ? void 0 : current.next) || null;
    }
    return current;
  }
  addNode(n) {
    const node = {
      value: n,
      previous: null,
      next: null
    };
    n.__ln = node;
    if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
      const current = n.previousSibling.__ln.next;
      node.next = current;
      node.previous = n.previousSibling.__ln;
      n.previousSibling.__ln.next = node;
      if (current) {
        current.previous = node;
      }
    } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
      const current = n.nextSibling.__ln.previous;
      node.previous = current;
      node.next = n.nextSibling.__ln;
      n.nextSibling.__ln.previous = node;
      if (current) {
        current.next = node;
      }
    } else {
      if (this.head) {
        this.head.previous = node;
      }
      node.next = this.head;
      this.head = node;
    }
    if (node.next === null) {
      this.tail = node;
    }
    this.length++;
  }
  removeNode(n) {
    const current = n.__ln;
    if (!this.head) {
      return;
    }
    if (!current.previous) {
      this.head = current.next;
      if (this.head) {
        this.head.previous = null;
      } else {
        this.tail = null;
      }
    } else {
      current.previous.next = current.next;
      if (current.next) {
        current.next.previous = current.previous;
      } else {
        this.tail = current.previous;
      }
    }
    if (n.__ln) {
      delete n.__ln;
    }
    this.length--;
  }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
class MutationBuffer {
  constructor() {
    this.frozen = false;
    this.locked = false;
    this.texts = [];
    this.attributes = [];
    this.removes = [];
    this.mapRemoves = [];
    this.movedMap = {};
    this.addedSet = new Set();
    this.movedSet = new Set();
    this.droppedSet = new Set();
    this.processMutations = mutations => {
      mutations.forEach(this.processMutation);
      this.emit();
    };
    this.emit = () => {
      if (this.frozen || this.locked) {
        return;
      }
      const adds = [];
      const addedIds = new Set();
      const addList = new DoubleLinkedList();
      const getNextId = n => {
        let ns = n;
        let nextId = IGNORED_NODE;
        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && this.mirror.getId(ns);
        }
        return nextId;
      };
      const pushAdd = n => {
        if (!n.parentNode || !inDom(n)) {
          return;
        }
        const parentId = isShadowRoot(n.parentNode) ? this.mirror.getId(getShadowHost(n)) : this.mirror.getId(n.parentNode);
        const nextId = getNextId(n);
        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n);
        }
        const sn = serializeNodeWithId(n, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: currentN => {
            if (isSerializedIframe(currentN, this.mirror)) {
              this.iframeManager.addIframe(currentN);
            }
            if (isSerializedStylesheet(currentN, this.mirror)) {
              this.stylesheetManager.trackLinkElement(currentN);
            }
            if (hasShadowRoot(n)) {
              this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
            }
          },
          onIframeLoad: (iframe, childSn) => {
            this.iframeManager.attachIframe(iframe, childSn);
            this.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: (link, childSn) => {
            this.stylesheetManager.attachLinkElement(link, childSn);
          }
        });
        if (sn) {
          adds.push({
            parentId,
            nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };
      while (this.mapRemoves.length) {
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      }
      for (const n of this.movedSet) {
        if (isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) {
          continue;
        }
        pushAdd(n);
      }
      for (const n of this.addedSet) {
        if (!isAncestorInSet(this.droppedSet, n) && !isParentRemoved(this.removes, n, this.mirror)) {
          pushAdd(n);
        } else if (isAncestorInSet(this.movedSet, n)) {
          pushAdd(n);
        } else {
          this.droppedSet.add(n);
        }
      }
      let candidate = null;
      while (addList.length) {
        let node = null;
        if (candidate) {
          const parentId = this.mirror.getId(candidate.value.parentNode);
          const nextId = getNextId(candidate.value);
          if (parentId !== -1 && nextId !== -1) {
            node = candidate;
          }
        }
        if (!node) {
          let tailNode = addList.tail;
          while (tailNode) {
            const _node = tailNode;
            tailNode = tailNode.previous;
            if (_node) {
              const parentId = this.mirror.getId(_node.value.parentNode);
              const nextId = getNextId(_node.value);
              if (nextId === -1) continue;else if (parentId !== -1) {
                node = _node;
                break;
              } else {
                const unhandledNode = _node.value;
                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const shadowHost = unhandledNode.parentNode.host;
                  const parentId = this.mirror.getId(shadowHost);
                  if (parentId !== -1) {
                    node = _node;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!node) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }
          break;
        }
        candidate = node.previous;
        addList.removeNode(node.value);
        pushAdd(node.value);
      }
      const payload = {
        texts: this.texts.map(text => ({
          id: this.mirror.getId(text.node),
          value: text.value
        })).filter(text => !addedIds.has(text.id)).filter(text => this.mirror.has(text.id)),
        attributes: this.attributes.map(attribute => {
          const {
            attributes
          } = attribute;
          if (typeof attributes.style === 'string') {
            const diffAsStr = JSON.stringify(attribute.styleDiff);
            const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }
          return {
            id: this.mirror.getId(attribute.node),
            attributes: attributes
          };
        }).filter(attribute => !addedIds.has(attribute.id)).filter(attribute => this.mirror.has(attribute.id)),
        removes: this.removes,
        adds
      };
      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }
      this.texts = [];
      this.attributes = [];
      this.removes = [];
      this.addedSet = new Set();
      this.movedSet = new Set();
      this.droppedSet = new Set();
      this.movedMap = {};
      this.mutationCb(payload);
    };
    this.processMutation = m => {
      if (isIgnored(m.target, this.mirror)) {
        return;
      }
      switch (m.type) {
        case 'characterData':
          {
            const value = m.target.textContent;
            if (!isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) {
              this.texts.push({
                value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                node: m.target
              });
            }
            break;
          }
        case 'attributes':
          {
            const target = m.target;
            let attributeName = m.attributeName;
            let value = m.target.getAttribute(attributeName);
            if (attributeName === 'value') {
              const type = getInputType$1(target);
              value = maskInputValue({
                element: target,
                maskInputOptions: this.maskInputOptions,
                tagName: target.tagName,
                type,
                value,
                maskInputFn: this.maskInputFn
              });
            }
            if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || value === m.oldValue) {
              return;
            }
            let item = this.attributes.find(a => a.node === m.target);
            if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
              if (!target.contentDocument) {
                attributeName = 'rr_src';
              } else {
                return;
              }
            }
            if (!item) {
              item = {
                node: m.target,
                attributes: {},
                styleDiff: {},
                _unchangedStyles: {}
              };
              this.attributes.push(item);
            }
            if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') {
              target.setAttribute('data-rr-is-password', 'true');
            }
            if (!ignoreAttribute(target.tagName, attributeName)) {
              item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase$1(target.tagName), toLowerCase$1(attributeName), value);
              if (attributeName === 'style') {
                let unattachedDoc;
                try {
                  unattachedDoc = document.implementation.createHTMLDocument();
                } catch (e) {
                  unattachedDoc = this.doc;
                }
                const old = unattachedDoc.createElement('span');
                if (m.oldValue) {
                  old.setAttribute('style', m.oldValue);
                }
                for (const pname of Array.from(target.style)) {
                  const newValue = target.style.getPropertyValue(pname);
                  const newPriority = target.style.getPropertyPriority(pname);
                  if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                    if (newPriority === '') {
                      item.styleDiff[pname] = newValue;
                    } else {
                      item.styleDiff[pname] = [newValue, newPriority];
                    }
                  } else {
                    item._unchangedStyles[pname] = [newValue, newPriority];
                  }
                }
                for (const pname of Array.from(old.style)) {
                  if (target.style.getPropertyValue(pname) === '') {
                    item.styleDiff[pname] = false;
                  }
                }
              }
            }
            break;
          }
        case 'childList':
          {
            if (isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;
            m.addedNodes.forEach(n => this.genAdds(n, m.target));
            m.removedNodes.forEach(n => {
              const nodeId = this.mirror.getId(n);
              const parentId = isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
              if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || isIgnored(n, this.mirror) || !isSerialized(n, this.mirror)) {
                return;
              }
              if (this.addedSet.has(n)) {
                deepDelete(this.addedSet, n);
                this.droppedSet.add(n);
              } else if (this.addedSet.has(m.target) && nodeId === -1) ;else if (isAncestorRemoved(m.target, this.mirror)) ;else if (this.movedSet.has(n) && this.movedMap[moveKey(nodeId, parentId)]) {
                deepDelete(this.movedSet, n);
              } else {
                this.removes.push({
                  parentId,
                  id: nodeId,
                  isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                });
              }
              this.mapRemoves.push(n);
            });
            break;
          }
      }
    };
    this.genAdds = (n, target) => {
      if (this.processedNodeManager.inOtherBuffer(n, this)) return;
      if (this.addedSet.has(n) || this.movedSet.has(n)) return;
      if (this.mirror.hasNode(n)) {
        if (isIgnored(n, this.mirror)) {
          return;
        }
        this.movedSet.add(n);
        let targetId = null;
        if (target && this.mirror.hasNode(target)) {
          targetId = this.mirror.getId(target);
        }
        if (targetId && targetId !== -1) {
          this.movedMap[moveKey(this.mirror.getId(n), targetId)] = true;
        }
      } else {
        this.addedSet.add(n);
        this.droppedSet.delete(n);
      }
      if (!isBlocked(n, this.blockClass, this.blockSelector, false)) {
        n.childNodes.forEach(childN => this.genAdds(childN));
        if (hasShadowRoot(n)) {
          n.shadowRoot.childNodes.forEach(childN => {
            this.processedNodeManager.add(childN, this);
            this.genAdds(childN, n);
          });
        }
      }
    };
  }
  init(options) {
    ['mutationCb', 'blockClass', 'blockSelector', 'maskTextClass', 'maskTextSelector', 'inlineStylesheet', 'maskInputOptions', 'maskTextFn', 'maskInputFn', 'keepIframeSrcFn', 'recordCanvas', 'inlineImages', 'slimDOMOptions', 'dataURLOptions', 'doc', 'mirror', 'iframeManager', 'stylesheetManager', 'shadowDomManager', 'canvasManager', 'processedNodeManager'].forEach(key => {
      this[key] = options[key];
    });
  }
  freeze() {
    this.frozen = true;
    this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = false;
    this.canvasManager.unfreeze();
    this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = true;
    this.canvasManager.lock();
  }
  unlock() {
    this.locked = false;
    this.canvasManager.unlock();
    this.emit();
  }
  reset() {
    this.shadowDomManager.reset();
    this.canvasManager.reset();
  }
}
function deepDelete(addsSet, n) {
  addsSet.delete(n);
  n.childNodes.forEach(childN => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
  if (removes.length === 0) return false;
  return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
  const {
    parentNode
  } = n;
  if (!parentNode) {
    return false;
  }
  const parentId = mirror.getId(parentNode);
  if (removes.some(r => r.id === parentId)) {
    return true;
  }
  return _isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
  const {
    parentNode
  } = n;
  if (!parentNode) {
    return false;
  }
  if (set.has(parentNode)) {
    return true;
  }
  return _isAncestorInSet(set, parentNode);
}
const mutationBuffers = [];
function getEventTarget(event) {
  try {
    if ('composedPath' in event) {
      const path = event.composedPath();
      if (path.length) {
        return path[0];
      }
    } else if ('path' in event && event.path.length) {
      return event.path[0];
    }
  } catch (_a) {}
  return event && event.target;
}
function initMutationObserver(options, rootEl) {
  var _a, _b;
  const mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
  const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
  if (angularZoneSymbol && window[angularZoneSymbol]) {
    mutationObserverCtor = window[angularZoneSymbol];
  }
  const observer = new mutationObserverCtor(callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}
function initMoveObserver({
  mousemoveCb,
  sampling,
  doc,
  mirror
}) {
  if (sampling.mousemove === false) {
    return () => {};
  }
  const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
  const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
  let positions = [];
  let timeBaseline;
  const wrappedCb = throttle(callbackWrapper(source => {
    const totalOffset = Date.now() - timeBaseline;
    mousemoveCb(positions.map(p => {
      p.timeOffset -= totalOffset;
      return p;
    }), source);
    positions = [];
    timeBaseline = null;
  }), callbackThreshold);
  const updatePosition = callbackWrapper(throttle(callbackWrapper(evt => {
    const target = getEventTarget(evt);
    const {
      clientX,
      clientY
    } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
    if (!timeBaseline) {
      timeBaseline = nowTimestamp();
    }
    positions.push({
      x: clientX,
      y: clientY,
      id: mirror.getId(target),
      timeOffset: nowTimestamp() - timeBaseline
    });
    wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
  }), threshold, {
    trailing: false
  }));
  const handlers = [on('mousemove', updatePosition, doc), on('touchmove', updatePosition, doc), on('drag', updatePosition, doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initMouseInteractionObserver({
  mouseInteractionCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  sampling
}) {
  if (sampling.mouseInteraction === false) {
    return () => {};
  }
  const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
  const handlers = [];
  let currentPointerType = null;
  const getHandler = eventKey => {
    return event => {
      const target = getEventTarget(event);
      if (isBlocked(target, blockClass, blockSelector, true)) {
        return;
      }
      let pointerType = null;
      let thisEventKey = eventKey;
      if ('pointerType' in event) {
        switch (event.pointerType) {
          case 'mouse':
            pointerType = PointerTypes.Mouse;
            break;
          case 'touch':
            pointerType = PointerTypes.Touch;
            break;
          case 'pen':
            pointerType = PointerTypes.Pen;
            break;
        }
        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions$1[eventKey] === MouseInteractions$1.MouseDown) {
            thisEventKey = 'TouchStart';
          } else if (MouseInteractions$1[eventKey] === MouseInteractions$1.MouseUp) {
            thisEventKey = 'TouchEnd';
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }
      if (pointerType !== null) {
        currentPointerType = pointerType;
        if (thisEventKey.startsWith('Touch') && pointerType === PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions$1[eventKey] === MouseInteractions$1.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }
      const e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
      if (!e) {
        return;
      }
      const id = mirror.getId(target);
      const {
        clientX,
        clientY
      } = e;
      callbackWrapper(mouseInteractionCb)(Object.assign({
        type: MouseInteractions$1[thisEventKey],
        id,
        x: clientX,
        y: clientY
      }, pointerType !== null && {
        pointerType
      }));
    };
  };
  Object.keys(MouseInteractions$1).filter(key => Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach(eventKey => {
    let eventName = toLowerCase$1(eventKey);
    const handler = getHandler(eventKey);
    if (window.PointerEvent) {
      switch (MouseInteractions$1[eventKey]) {
        case MouseInteractions$1.MouseDown:
        case MouseInteractions$1.MouseUp:
          eventName = eventName.replace('mouse', 'pointer');
          break;
        case MouseInteractions$1.TouchStart:
        case MouseInteractions$1.TouchEnd:
          return;
      }
    }
    handlers.push(on(eventName, handler, doc));
  });
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initScrollObserver({
  scrollCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  sampling
}) {
  const updatePosition = callbackWrapper(throttle(callbackWrapper(evt => {
    const target = getEventTarget(evt);
    if (!target || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }
    const id = mirror.getId(target);
    if (target === doc && doc.defaultView) {
      const scrollLeftTop = getWindowScroll(doc.defaultView);
      scrollCb({
        id,
        x: scrollLeftTop.left,
        y: scrollLeftTop.top
      });
    } else {
      scrollCb({
        id,
        x: target.scrollLeft,
        y: target.scrollTop
      });
    }
  }), sampling.scroll || 100));
  return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver({
  viewportResizeCb
}, {
  win
}) {
  let lastH = -1;
  let lastW = -1;
  const updateDimension = callbackWrapper(throttle(callbackWrapper(() => {
    const height = getWindowHeight$1();
    const width = getWindowWidth$1();
    if (lastH !== height || lastW !== width) {
      viewportResizeCb({
        width: Number(width),
        height: Number(height)
      });
      lastH = height;
      lastW = width;
    }
  }), 200));
  return on('resize', updateDimension, win);
}
function wrapEventWithUserTriggeredFlag(v, enable) {
  const value = Object.assign({}, v);
  if (!enable) delete value.userTriggered;
  return value;
}
const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const lastInputValueMap = new WeakMap();
function initInputObserver({
  inputCb,
  doc,
  mirror,
  blockClass,
  blockSelector,
  ignoreClass,
  ignoreSelector,
  maskInputOptions,
  maskInputFn,
  sampling,
  userTriggeredOnInput
}) {
  function eventHandler(event) {
    let target = getEventTarget(event);
    const userTriggered = event.isTrusted;
    const tagName = target && target.tagName;
    if (target && tagName === 'OPTION') {
      target = target.parentElement;
    }
    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }
    if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) {
      return;
    }
    let text = target.value;
    let isChecked = false;
    const type = getInputType$1(target) || '';
    if (type === 'radio' || type === 'checkbox') {
      isChecked = target.checked;
    } else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) {
      text = maskInputValue({
        element: target,
        maskInputOptions,
        tagName,
        type,
        value: text,
        maskInputFn
      });
    }
    cbWithDedup(target, callbackWrapper(wrapEventWithUserTriggeredFlag)({
      text,
      isChecked,
      userTriggered
    }, userTriggeredOnInput));
    const name = target.name;
    if (type === 'radio' && name && isChecked) {
      doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(el => {
        if (el !== target) {
          cbWithDedup(el, callbackWrapper(wrapEventWithUserTriggeredFlag)({
            text: el.value,
            isChecked: !isChecked,
            userTriggered: false
          }, userTriggeredOnInput));
        }
      });
    }
  }
  function cbWithDedup(target, v) {
    const lastInputValue = lastInputValueMap.get(target);
    if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
      lastInputValueMap.set(target, v);
      const id = mirror.getId(target);
      callbackWrapper(inputCb)(Object.assign(Object.assign({}, v), {
        id
      }));
    }
  }
  const events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
  const handlers = events.map(eventName => on(eventName, callbackWrapper(eventHandler), doc));
  const currentWindow = doc.defaultView;
  if (!currentWindow) {
    return () => {
      handlers.forEach(h => h());
    };
  }
  const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
  const hookProperties = [[currentWindow.HTMLInputElement.prototype, 'value'], [currentWindow.HTMLInputElement.prototype, 'checked'], [currentWindow.HTMLSelectElement.prototype, 'value'], [currentWindow.HTMLTextAreaElement.prototype, 'value'], [currentWindow.HTMLSelectElement.prototype, 'selectedIndex'], [currentWindow.HTMLOptionElement.prototype, 'selected']];
  if (propertyDescriptor && propertyDescriptor.set) {
    handlers.push(...hookProperties.map(p => hookSetter(p[0], p[1], {
      set() {
        callbackWrapper(eventHandler)({
          target: this,
          isTrusted: false
        });
      }
    }, false, currentWindow)));
  }
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function getNestedCSSRulePositions(rule) {
  const positions = [];
  function recurse(childRule, pos) {
    if (hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
      const rules = Array.from(childRule.parentRule.cssRules);
      const index = rules.indexOf(childRule);
      pos.unshift(index);
    } else if (childRule.parentStyleSheet) {
      const rules = Array.from(childRule.parentStyleSheet.cssRules);
      const index = rules.indexOf(childRule);
      pos.unshift(index);
    }
    return pos;
  }
  return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
  let id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);else styleId = styleMirror.getId(sheet);
  return {
    styleId,
    id
  };
}
function initStyleSheetObserver({
  styleSheetRuleCb,
  mirror,
  stylesheetManager
}, {
  win
}) {
  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return () => {};
  }
  const insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [rule, index] = argumentsList;
      const {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          adds: [{
            rule,
            index
          }]
        });
      }
      return externalFunctionWrapper(() => target.apply(thisArg, argumentsList))();
    })
  });
  const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      const [index] = argumentsList;
      const {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          removes: [{
            index
          }]
        });
      }
      return externalFunctionWrapper(() => target.apply(thisArg, argumentsList))();
    })
  });
  let replace;
  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [text] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replace: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  let replaceSync;
  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [text] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replaceSync: text
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  }
  const supportedNestedCSSRuleTypes = {};
  if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }
    if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }
  const unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
    unmodifiedFunctions[typeKey] = {
      insertRule: type.prototype.insertRule,
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [rule, index] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            adds: [{
              rule,
              index: [...getNestedCSSRulePositions(thisArg), index || 0]
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
    type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        const [index] = argumentsList;
        const {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            removes: [{
              index: [...getNestedCSSRulePositions(thisArg), index]
            }]
          });
        }
        return target.apply(thisArg, argumentsList);
      })
    });
  });
  return callbackWrapper(() => {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}
function initAdoptedStyleSheetObserver({
  mirror,
  stylesheetManager
}, host) {
  var _a, _b, _c;
  let hostId = null;
  if (host.nodeName === '#document') hostId = mirror.getId(host);else hostId = mirror.getId(host.host);
  const patchTarget = host.nodeName === '#document' ? (_a = host.defaultView) === null || _a === void 0 ? void 0 : _a.Document : (_c = (_b = host.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.ShadowRoot;
  const originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, 'adoptedStyleSheets') : undefined;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return () => {};
  Object.defineProperty(host, 'adoptedStyleSheets', {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,
    get() {
      var _a;
      return (_a = originalPropertyDescriptor.get) === null || _a === void 0 ? void 0 : _a.call(this);
    },
    set(sheets) {
      var _a;
      const result = (_a = originalPropertyDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(this, sheets);
      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e) {}
      }
      return result;
    }
  });
  return callbackWrapper(() => {
    Object.defineProperty(host, 'adoptedStyleSheets', {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      get: originalPropertyDescriptor.get,
      set: originalPropertyDescriptor.set
    });
  });
}
function initStyleDeclarationObserver({
  styleDeclarationCb,
  mirror,
  ignoreCSSAttributes,
  stylesheetManager
}, {
  win
}) {
  const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var _a;
      const [property, value, priority] = argumentsList;
      if (ignoreCSSAttributes.has(property)) {
        return setProperty.apply(thisArg, [property, value, priority]);
      }
      const {
        id,
        styleId
      } = getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          set: {
            property,
            value,
            priority
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var _a;
      const [property] = argumentsList;
      if (ignoreCSSAttributes.has(property)) {
        return removeProperty.apply(thisArg, [property]);
      }
      const {
        id,
        styleId
      } = getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          remove: {
            property
          },
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }
      return target.apply(thisArg, argumentsList);
    })
  });
  return callbackWrapper(() => {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}
function initMediaInteractionObserver({
  mediaInteractionCb,
  blockClass,
  blockSelector,
  mirror,
  sampling,
  doc
}) {
  const handler = callbackWrapper(type => throttle(callbackWrapper(event => {
    const target = getEventTarget(event);
    if (!target || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }
    const {
      currentTime,
      volume,
      muted,
      playbackRate
    } = target;
    mediaInteractionCb({
      type,
      id: mirror.getId(target),
      currentTime,
      volume,
      muted,
      playbackRate
    });
  }), sampling.media || 500));
  const handlers = [on('play', handler(0), doc), on('pause', handler(1), doc), on('seeked', handler(2), doc), on('volumechange', handler(3), doc), on('ratechange', handler(4), doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initFontObserver({
  fontCb,
  doc
}) {
  const win = doc.defaultView;
  if (!win) {
    return () => {};
  }
  const handlers = [];
  const fontMap = new WeakMap();
  const originalFontFace = win.FontFace;
  win.FontFace = function FontFace(family, source, descriptors) {
    const fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family,
      buffer: typeof source !== 'string',
      descriptors,
      fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };
  const restoreHandler = patch(doc.fonts, 'add', function (original) {
    return function (fontFace) {
      setTimeout(callbackWrapper(() => {
        const p = fontMap.get(fontFace);
        if (p) {
          fontCb(p);
          fontMap.delete(fontFace);
        }
      }), 0);
      return original.apply(this, [fontFace]);
    };
  });
  handlers.push(() => {
    win.FontFace = originalFontFace;
  });
  handlers.push(restoreHandler);
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}
function initSelectionObserver(param) {
  const {
    doc,
    mirror,
    blockClass,
    blockSelector,
    selectionCb
  } = param;
  let collapsed = true;
  const updateSelection = callbackWrapper(() => {
    const selection = doc.getSelection();
    if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
    collapsed = selection.isCollapsed || false;
    const ranges = [];
    const count = selection.rangeCount || 0;
    for (let i = 0; i < count; i++) {
      const range = selection.getRangeAt(i);
      const {
        startContainer,
        startOffset,
        endContainer,
        endOffset
      } = range;
      const blocked = isBlocked(startContainer, blockClass, blockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, true);
      if (blocked) continue;
      ranges.push({
        start: mirror.getId(startContainer),
        startOffset,
        end: mirror.getId(endContainer),
        endOffset
      });
    }
    selectionCb({
      ranges
    });
  });
  updateSelection();
  return on('selectionchange', updateSelection);
}
function mergeHooks(o, hooks) {
  const {
    mutationCb,
    mousemoveCb,
    mouseInteractionCb,
    scrollCb,
    viewportResizeCb,
    inputCb,
    mediaInteractionCb,
    styleSheetRuleCb,
    styleDeclarationCb,
    canvasMutationCb,
    fontCb,
    selectionCb
  } = o;
  o.mutationCb = (...p) => {
    if (hooks.mutation) {
      hooks.mutation(...p);
    }
    mutationCb(...p);
  };
  o.mousemoveCb = (...p) => {
    if (hooks.mousemove) {
      hooks.mousemove(...p);
    }
    mousemoveCb(...p);
  };
  o.mouseInteractionCb = (...p) => {
    if (hooks.mouseInteraction) {
      hooks.mouseInteraction(...p);
    }
    mouseInteractionCb(...p);
  };
  o.scrollCb = (...p) => {
    if (hooks.scroll) {
      hooks.scroll(...p);
    }
    scrollCb(...p);
  };
  o.viewportResizeCb = (...p) => {
    if (hooks.viewportResize) {
      hooks.viewportResize(...p);
    }
    viewportResizeCb(...p);
  };
  o.inputCb = (...p) => {
    if (hooks.input) {
      hooks.input(...p);
    }
    inputCb(...p);
  };
  o.mediaInteractionCb = (...p) => {
    if (hooks.mediaInteaction) {
      hooks.mediaInteaction(...p);
    }
    mediaInteractionCb(...p);
  };
  o.styleSheetRuleCb = (...p) => {
    if (hooks.styleSheetRule) {
      hooks.styleSheetRule(...p);
    }
    styleSheetRuleCb(...p);
  };
  o.styleDeclarationCb = (...p) => {
    if (hooks.styleDeclaration) {
      hooks.styleDeclaration(...p);
    }
    styleDeclarationCb(...p);
  };
  o.canvasMutationCb = (...p) => {
    if (hooks.canvasMutation) {
      hooks.canvasMutation(...p);
    }
    canvasMutationCb(...p);
  };
  o.fontCb = (...p) => {
    if (hooks.font) {
      hooks.font(...p);
    }
    fontCb(...p);
  };
  o.selectionCb = (...p) => {
    if (hooks.selection) {
      hooks.selection(...p);
    }
    selectionCb(...p);
  };
}
function initObservers(o, hooks = {}) {
  const currentWindow = o.doc.defaultView;
  if (!currentWindow) {
    return () => {};
  }
  mergeHooks(o, hooks);
  let mutationObserver;
  if (o.recordDOM) {
    mutationObserver = initMutationObserver(o, o.doc);
  }
  const mousemoveHandler = initMoveObserver(o);
  const mouseInteractionHandler = initMouseInteractionObserver(o);
  const scrollHandler = initScrollObserver(o);
  const viewportResizeHandler = initViewportResizeObserver(o, {
    win: currentWindow
  });
  const inputHandler = initInputObserver(o);
  const mediaInteractionHandler = initMediaInteractionObserver(o);
  let styleSheetObserver = () => {};
  let adoptedStyleSheetObserver = () => {};
  let styleDeclarationObserver = () => {};
  let fontObserver = () => {};
  if (o.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o, {
      win: currentWindow
    });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o, {
      win: currentWindow
    });
    if (o.collectFonts) {
      fontObserver = initFontObserver(o);
    }
  }
  const selectionObserver = initSelectionObserver(o);
  const pluginHandlers = [];
  for (const plugin of o.plugins) {
    pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
  }
  return callbackWrapper(() => {
    mutationBuffers.forEach(b => b.reset());
    mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    pluginHandlers.forEach(h => h());
  });
}
function hasNestedCSSRule(prop) {
  return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function funcToSource(fn, sourcemapArg) {
  var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
  var source = fn.toString();
  var lines = source.split('\n');
  lines.pop();
  lines.shift();
  var blankPrefixLength = lines[0].search(/\S/);
  var regex = /(['"])__worker_loader_strict__(['"])/g;
  for (var i = 0, n = lines.length; i < n; ++i) {
    lines[i] = lines[i].substring(blankPrefixLength).replace(regex, '$1use strict$2') + '\n';
  }
  if (sourcemap) {
    lines.push('\/\/# sourceMappingURL=' + sourcemap + '\n');
  }
  return lines;
}
function createURL(fn, sourcemapArg) {
  var lines = funcToSource(fn, sourcemapArg);
  var blob = new Blob(lines, {
    type: 'application/javascript'
  });
  return URL.createObjectURL(blob);
}
function createInlineWorkerFactory(fn, sourcemapArg) {
  var url;
  return function WorkerFactory(options) {
    url = url || createURL(fn, sourcemapArg);
    return new Worker(url, options);
  };
}
var WorkerFactory = createInlineWorkerFactory( /* rollup-plugin-web-worker-loader */function () {
  (function () {
    '__worker_loader_strict__';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
      Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    }

    /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
      lookup[chars.charCodeAt(i)] = i;
    }
    var encode = function encode(arraybuffer) {
      var bytes = new Uint8Array(arraybuffer),
        i,
        len = bytes.length,
        base64 = '';
      for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
      }
      if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
      } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
      }
      return base64;
    };
    const lastBlobMap = new Map();
    const transparentBlobMap = new Map();
    function getTransparentBlobFor(width, height, dataURLOptions) {
      return __awaiter(this, void 0, void 0, function* () {
        const id = `${width}-${height}`;
        if ('OffscreenCanvas' in globalThis) {
          if (transparentBlobMap.has(id)) return transparentBlobMap.get(id);
          const offscreen = new OffscreenCanvas(width, height);
          offscreen.getContext('2d');
          const blob = yield offscreen.convertToBlob(dataURLOptions);
          const arrayBuffer = yield blob.arrayBuffer();
          const base64 = encode(arrayBuffer);
          transparentBlobMap.set(id, base64);
          return base64;
        } else {
          return '';
        }
      });
    }
    const worker = self;
    worker.onmessage = function (e) {
      return __awaiter(this, void 0, void 0, function* () {
        if ('OffscreenCanvas' in globalThis) {
          const {
            id,
            bitmap,
            width,
            height,
            dataURLOptions
          } = e.data;
          const transparentBase64 = getTransparentBlobFor(width, height, dataURLOptions);
          const offscreen = new OffscreenCanvas(width, height);
          const ctx = offscreen.getContext('2d');
          ctx.drawImage(bitmap, 0, 0);
          bitmap.close();
          const blob = yield offscreen.convertToBlob(dataURLOptions);
          const type = blob.type;
          const arrayBuffer = yield blob.arrayBuffer();
          const base64 = encode(arrayBuffer);
          if (!lastBlobMap.has(id) && (yield transparentBase64) === base64) {
            lastBlobMap.set(id, base64);
            return worker.postMessage({
              id
            });
          }
          if (lastBlobMap.get(id) === base64) return worker.postMessage({
            id
          });
          worker.postMessage({
            id,
            type,
            base64,
            width,
            height
          });
          lastBlobMap.set(id, base64);
        } else {
          return worker.postMessage({
            id: e.data.id
          });
        }
      });
    };
  })();
}, null);

/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i$1 = 0; i$1 < chars.length; i$1++) {
  lookup[chars.charCodeAt(i$1)] = i$1;
}
var encode = function encode(arraybuffer) {
  var bytes = new Uint8Array(arraybuffer),
    i,
    len = bytes.length,
    base64 = '';
  for (i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
    base64 += chars[bytes[i + 2] & 63];
  }
  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }
  return base64;
};
const canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
  let contextMap = canvasVarMap.get(ctx);
  if (!contextMap) {
    contextMap = new Map();
    canvasVarMap.set(ctx, contextMap);
  }
  if (!contextMap.has(ctor)) {
    contextMap.set(ctor, []);
  }
  return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx) => {
  if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
  const name = value.constructor.name;
  const list = variableListFor(ctx, name);
  let index = list.indexOf(value);
  if (index === -1) {
    index = list.length;
    list.push(value);
  }
  return index;
};
function serializeArg(value, win, ctx) {
  if (value instanceof Array) {
    return value.map(arg => serializeArg(arg, win, ctx));
  } else if (value === null) {
    return value;
  } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
    const name = value.constructor.name;
    return {
      rr_type: name,
      args: [Object.values(value)]
    };
  } else if (value instanceof ArrayBuffer) {
    const name = value.constructor.name;
    const base64 = encode(value);
    return {
      rr_type: name,
      base64
    };
  } else if (value instanceof DataView) {
    const name = value.constructor.name;
    return {
      rr_type: name,
      args: [serializeArg(value.buffer, win, ctx), value.byteOffset, value.byteLength]
    };
  } else if (value instanceof HTMLImageElement) {
    const name = value.constructor.name;
    const {
      src
    } = value;
    return {
      rr_type: name,
      src
    };
  } else if (value instanceof HTMLCanvasElement) {
    const name = 'HTMLImageElement';
    const src = value.toDataURL();
    return {
      rr_type: name,
      src
    };
  } else if (value instanceof ImageData) {
    const name = value.constructor.name;
    return {
      rr_type: name,
      args: [serializeArg(value.data, win, ctx), value.width, value.height]
    };
  } else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
    const name = value.constructor.name;
    const index = saveWebGLVar(value, win, ctx);
    return {
      rr_type: name,
      index: index
    };
  }
  return value;
}
const serializeArgs = (args, win, ctx) => {
  return [...args].map(arg => serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win) => {
  const webGLConstructorNames = ['WebGLActiveInfo', 'WebGLBuffer', 'WebGLFramebuffer', 'WebGLProgram', 'WebGLRenderbuffer', 'WebGLShader', 'WebGLShaderPrecisionFormat', 'WebGLTexture', 'WebGLUniformLocation', 'WebGLVertexArrayObject', 'WebGLVertexArrayObjectOES'];
  const supportedWebGLConstructorNames = webGLConstructorNames.filter(name => typeof win[name] === 'function');
  return Boolean(supportedWebGLConstructorNames.find(name => value instanceof win[name]));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
  const handlers = [];
  const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
  for (const prop of props2D) {
    try {
      if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
        continue;
      }
      const restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
        return function (...args) {
          if (!isBlocked(this.canvas, blockClass, blockSelector, true)) {
            setTimeout(() => {
              const recordArgs = serializeArgs([...args], win, this);
              cb(this.canvas, {
                type: CanvasContext['2D'],
                property: prop,
                args: recordArgs
              });
            }, 0);
          }
          return original.apply(this, args);
        };
      });
      handlers.push(restoreHandler);
    } catch (_a) {
      const hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
        set(v) {
          cb(this.canvas, {
            type: CanvasContext['2D'],
            property: prop,
            args: [v],
            setter: true
          });
        }
      });
      handlers.push(hookHandler);
    }
  }
  return () => {
    handlers.forEach(h => h());
  };
}
function getNormalizedContextName(contextType) {
  return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
  const handlers = [];
  try {
    const restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
      return function (contextType, ...args) {
        if (!isBlocked(this, blockClass, blockSelector, true)) {
          const ctxName = getNormalizedContextName(contextType);
          if (!('__context' in this)) this.__context = ctxName;
          if (setPreserveDrawingBufferToTrue && ['webgl', 'webgl2'].includes(ctxName)) {
            if (args[0] && typeof args[0] === 'object') {
              const contextAttributes = args[0];
              if (!contextAttributes.preserveDrawingBuffer) {
                contextAttributes.preserveDrawingBuffer = true;
              }
            } else {
              args.splice(0, 1, {
                preserveDrawingBuffer: true
              });
            }
          }
        }
        return original.apply(this, [contextType, ...args]);
      };
    });
    handlers.push(restoreHandler);
  } catch (_a) {
    console.error('failed to patch HTMLCanvasElement.prototype.getContext');
  }
  return () => {
    handlers.forEach(h => h());
  };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, mirror, win) {
  const handlers = [];
  const props = Object.getOwnPropertyNames(prototype);
  for (const prop of props) {
    if (['isContextLost', 'canvas', 'drawingBufferWidth', 'drawingBufferHeight'].includes(prop)) {
      continue;
    }
    try {
      if (typeof prototype[prop] !== 'function') {
        continue;
      }
      const restoreHandler = patch(prototype, prop, function (original) {
        return function (...args) {
          const result = original.apply(this, args);
          saveWebGLVar(result, win, this);
          if ('tagName' in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, true)) {
            const recordArgs = serializeArgs([...args], win, this);
            const mutation = {
              type,
              property: prop,
              args: recordArgs
            };
            cb(this.canvas, mutation);
          }
          return result;
        };
      });
      handlers.push(restoreHandler);
    } catch (_a) {
      const hookHandler = hookSetter(prototype, prop, {
        set(v) {
          cb(this.canvas, {
            type,
            property: prop,
            args: [v],
            setter: true
          });
        }
      });
      handlers.push(hookHandler);
    }
  }
  return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, mirror) {
  const handlers = [];
  handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, mirror, win));
  if (typeof win.WebGL2RenderingContext !== 'undefined') {
    handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, mirror, win));
  }
  return () => {
    handlers.forEach(h => h());
  };
}
class CanvasManager {
  reset() {
    this.pendingCanvasMutations.clear();
    this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = true;
  }
  unfreeze() {
    this.frozen = false;
  }
  lock() {
    this.locked = true;
  }
  unlock() {
    this.locked = false;
  }
  constructor(options) {
    this.pendingCanvasMutations = new Map();
    this.rafStamps = {
      latestId: 0,
      invokeId: null
    };
    this.frozen = false;
    this.locked = false;
    this.processMutation = (target, mutation) => {
      const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
      if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
      if (!this.pendingCanvasMutations.has(target)) {
        this.pendingCanvasMutations.set(target, []);
      }
      this.pendingCanvasMutations.get(target).push(mutation);
    };
    const {
      sampling = 'all',
      win,
      blockClass,
      blockSelector,
      recordCanvas,
      dataURLOptions
    } = options;
    this.mutationCb = options.mutationCb;
    this.mirror = options.mirror;
    if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector);
    if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
      dataURLOptions
    });
  }
  initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
    const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, true);
    const snapshotInProgressMap = new Map();
    const worker = new WorkerFactory();
    worker.onmessage = e => {
      const {
        id
      } = e.data;
      snapshotInProgressMap.set(id, false);
      if (!('base64' in e.data)) return;
      const {
        base64,
        type,
        width,
        height
      } = e.data;
      this.mutationCb({
        id,
        type: CanvasContext['2D'],
        commands: [{
          property: 'clearRect',
          args: [0, 0, width, height]
        }, {
          property: 'drawImage',
          args: [{
            rr_type: 'ImageBitmap',
            args: [{
              rr_type: 'Blob',
              data: [{
                rr_type: 'ArrayBuffer',
                base64
              }],
              type
            }]
          }, 0, 0]
        }]
      });
    };
    const timeBetweenSnapshots = 1000 / fps;
    let lastSnapshotTime = 0;
    let rafId;
    const getCanvas = () => {
      const matchedCanvas = [];
      win.document.querySelectorAll('canvas').forEach(canvas => {
        if (!isBlocked(canvas, blockClass, blockSelector, true)) {
          matchedCanvas.push(canvas);
        }
      });
      return matchedCanvas;
    };
    const takeCanvasSnapshots = timestamp => {
      if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        return;
      }
      lastSnapshotTime = timestamp;
      getCanvas().forEach(canvas => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const id = this.mirror.getId(canvas);
        if (snapshotInProgressMap.get(id)) return;
        snapshotInProgressMap.set(id, true);
        if (['webgl', 'webgl2'].includes(canvas.__context)) {
          const context = canvas.getContext(canvas.__context);
          if (((_a = context === null || context === void 0 ? void 0 : context.getContextAttributes()) === null || _a === void 0 ? void 0 : _a.preserveDrawingBuffer) === false) {
            context.clear(context.COLOR_BUFFER_BIT);
          }
        }
        const bitmap = yield createImageBitmap(canvas);
        worker.postMessage({
          id,
          bitmap,
          width: canvas.width,
          height: canvas.height,
          dataURLOptions: options.dataURLOptions
        }, [bitmap]);
      }));
      rafId = requestAnimationFrame(takeCanvasSnapshots);
    };
    rafId = requestAnimationFrame(takeCanvasSnapshots);
    this.resetObservers = () => {
      canvasContextReset();
      cancelAnimationFrame(rafId);
    };
  }
  initCanvasMutationObserver(win, blockClass, blockSelector) {
    this.startRAFTimestamping();
    this.startPendingCanvasMutationFlusher();
    const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, false);
    const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
    const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, this.mirror);
    this.resetObservers = () => {
      canvasContextReset();
      canvas2DReset();
      canvasWebGL1and2Reset();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const setLatestRAFTimestamp = timestamp => {
      this.rafStamps.latestId = timestamp;
      requestAnimationFrame(setLatestRAFTimestamp);
    };
    requestAnimationFrame(setLatestRAFTimestamp);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((values, canvas) => {
      const id = this.mirror.getId(canvas);
      this.flushPendingCanvasMutationFor(canvas, id);
    });
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(canvas, id) {
    if (this.frozen || this.locked) {
      return;
    }
    const valuesWithType = this.pendingCanvasMutations.get(canvas);
    if (!valuesWithType || id === -1) return;
    const values = valuesWithType.map(value => {
      const rest = __rest(value, ["type"]);
      return rest;
    });
    const {
      type
    } = valuesWithType[0];
    this.mutationCb({
      id,
      type,
      commands: values
    });
    this.pendingCanvasMutations.delete(canvas);
  }
}
class ProcessedNodeManager {
  constructor() {
    this.nodeMap = new WeakMap();
    this.loop = true;
    this.periodicallyClear();
  }
  periodicallyClear() {
    requestAnimationFrame(() => {
      this.clear();
      if (this.loop) this.periodicallyClear();
    });
  }
  inOtherBuffer(node, thisBuffer) {
    const buffers = this.nodeMap.get(node);
    return buffers && Array.from(buffers).some(buffer => buffer !== thisBuffer);
  }
  add(node, buffer) {
    this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
  }
  clear() {
    this.nodeMap = new WeakMap();
  }
  destroy() {
    this.loop = false;
  }
}
class ShadowDomManager {
  constructor(options) {
    this.shadowDoms = new WeakSet();
    this.restoreHandlers = [];
    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }
  init() {
    this.reset();
    this.patchAttachShadow(Element, document);
  }
  addShadowRoot(shadowRoot, doc) {
    if (!isNativeShadowDom(shadowRoot)) return;
    if (this.shadowDoms.has(shadowRoot)) return;
    this.shadowDoms.add(shadowRoot);
    const observer = initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
      doc,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }), shadowRoot);
    this.restoreHandlers.push(() => observer.disconnect());
    this.restoreHandlers.push(initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
      scrollCb: this.scrollCb,
      doc: shadowRoot,
      mirror: this.mirror
    })));
    setTimeout(() => {
      if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
      this.restoreHandlers.push(initAdoptedStyleSheetObserver({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, shadowRoot));
    }, 0);
  }
  observeAttachShadow(iframeElement) {
    if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
    this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
  }
  patchAttachShadow(element, doc) {
    const manager = this;
    this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
      return function (option) {
        const shadowRoot = original.call(this, option);
        if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
        return shadowRoot;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach(handler => {
      try {
        handler();
      } catch (e) {}
    });
    this.restoreHandlers = [];
    this.shadowDoms = new WeakSet();
  }
}
class StylesheetManager {
  constructor(options) {
    this.trackedLinkElements = new WeakSet();
    this.styleMirror = new StyleSheetMirror();
    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }
  attachLinkElement(linkEl, childSn) {
    if ('_cssText' in childSn.attributes) this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [{
        id: childSn.id,
        attributes: childSn.attributes
      }]
    });
    this.trackLinkElement(linkEl);
  }
  trackLinkElement(linkEl) {
    if (this.trackedLinkElements.has(linkEl)) return;
    this.trackedLinkElements.add(linkEl);
    this.trackStylesheetInLinkElement(linkEl);
  }
  adoptStyleSheets(sheets, hostId) {
    if (sheets.length === 0) return;
    const adoptedStyleSheetData = {
      id: hostId,
      styleIds: []
    };
    const styles = [];
    for (const sheet of sheets) {
      let styleId;
      if (!this.styleMirror.has(sheet)) {
        styleId = this.styleMirror.add(sheet);
        styles.push({
          styleId,
          rules: Array.from(sheet.rules || CSSRule, (r, index) => ({
            rule: stringifyRule(r),
            index
          }))
        });
      } else styleId = this.styleMirror.getId(sheet);
      adoptedStyleSheetData.styleIds.push(styleId);
    }
    if (styles.length > 0) adoptedStyleSheetData.styles = styles;
    this.adoptedStyleSheetCb(adoptedStyleSheetData);
  }
  reset() {
    this.styleMirror.reset();
    this.trackedLinkElements = new WeakSet();
  }
  trackStylesheetInLinkElement(linkEl) {}
}
function wrapEvent(e) {
  return Object.assign(Object.assign({}, e), {
    timestamp: nowTimestamp()
  });
}
let wrappedEmit;
let takeFullSnapshot;
let canvasManager;
let recording = false;
const mirror = createMirror();
function record(options = {}) {
  const {
    emit,
    checkoutEveryNms,
    checkoutEveryNth,
    blockClass = 'rr-block',
    blockSelector = null,
    ignoreClass = 'rr-ignore',
    ignoreSelector = null,
    maskTextClass = 'rr-mask',
    maskTextSelector = null,
    inlineStylesheet = true,
    maskAllInputs,
    maskInputOptions: _maskInputOptions,
    slimDOMOptions: _slimDOMOptions,
    maskInputFn,
    maskTextFn,
    hooks,
    packFn,
    sampling = {},
    dataURLOptions = {},
    mousemoveWait,
    recordDOM = true,
    recordCanvas = false,
    recordCrossOriginIframes = false,
    recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load',
    userTriggeredOnInput = false,
    collectFonts = false,
    inlineImages = false,
    plugins,
    keepIframeSrcFn = () => false,
    ignoreCSSAttributes = new Set([]),
    errorHandler
  } = options;
  registerErrorHandler(errorHandler);
  const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  let passEmitsToParent = false;
  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e) {
      passEmitsToParent = true;
    }
  }
  if (inEmittingFrame && !emit) {
    throw new Error('emit function is required');
  }
  if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
    sampling.mousemove = mousemoveWait;
  }
  mirror.reset();
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    password: true
  } : _maskInputOptions !== undefined ? _maskInputOptions : {
    password: true
  };
  const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    headMetaAuthorship: _slimDOMOptions === 'all',
    headMetaDescKeywords: _slimDOMOptions === 'all'
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill();
  let lastFullSnapshotEvent;
  let incrementalSnapshotCount = 0;
  const eventProcessor = e => {
    for (const plugin of plugins || []) {
      if (plugin.eventProcessor) {
        e = plugin.eventProcessor(e);
      }
    }
    if (packFn && !passEmitsToParent) {
      e = packFn(e);
    }
    return e;
  };
  wrappedEmit = (e, isCheckout) => {
    var _a;
    if (((_a = mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach(buf => buf.unfreeze());
    }
    if (inEmittingFrame) {
      emit === null || emit === void 0 ? void 0 : emit(eventProcessor(e), isCheckout);
    } else if (passEmitsToParent) {
      const message = {
        type: 'rrweb',
        event: eventProcessor(e),
        origin: window.location.origin,
        isCheckout
      };
      window.parent.postMessage(message, '*');
    }
    if (e.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e;
      incrementalSnapshotCount = 0;
    } else if (e.type === EventType.IncrementalSnapshot) {
      if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) {
        return;
      }
      incrementalSnapshotCount++;
      const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
      if (exceedCount || exceedTime) {
        takeFullSnapshot(true);
      }
    }
  };
  const wrappedMutationEmit = m => {
    wrappedEmit(wrapEvent({
      type: EventType.IncrementalSnapshot,
      data: Object.assign({
        source: IncrementalSource.Mutation
      }, m)
    }));
  };
  const wrappedScrollEmit = p => wrappedEmit(wrapEvent({
    type: EventType.IncrementalSnapshot,
    data: Object.assign({
      source: IncrementalSource.Scroll
    }, p)
  }));
  const wrappedCanvasMutationEmit = p => wrappedEmit(wrapEvent({
    type: EventType.IncrementalSnapshot,
    data: Object.assign({
      source: IncrementalSource.CanvasMutation
    }, p)
  }));
  const wrappedAdoptedStyleSheetEmit = a => wrappedEmit(wrapEvent({
    type: EventType.IncrementalSnapshot,
    data: Object.assign({
      source: IncrementalSource.AdoptedStyleSheet
    }, a)
  }));
  const stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  const iframeManager = new IframeManager({
    mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager: stylesheetManager,
    recordCrossOriginIframes,
    wrappedEmit
  });
  for (const plugin of plugins || []) {
    if (plugin.getMirror) plugin.getMirror({
      nodeMirror: mirror,
      crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
  }
  const processedNodeManager = new ProcessedNodeManager();
  canvasManager = new CanvasManager({
    recordCanvas,
    mutationCb: wrappedCanvasMutationEmit,
    win: window,
    blockClass,
    blockSelector,
    mirror,
    sampling: sampling.canvas,
    dataURLOptions
  });
  const shadowDomManager = new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      inlineStylesheet,
      maskInputOptions,
      dataURLOptions,
      maskTextFn,
      maskInputFn,
      recordCanvas,
      inlineImages,
      sampling,
      slimDOMOptions,
      iframeManager,
      stylesheetManager,
      canvasManager,
      keepIframeSrcFn,
      processedNodeManager
    },
    mirror
  });
  takeFullSnapshot = (isCheckout = false) => {
    if (!recordDOM) {
      return;
    }
    wrappedEmit(wrapEvent({
      type: EventType.Meta,
      data: {
        href: window.location.href,
        width: getWindowWidth$1(),
        height: getWindowHeight$1()
      }
    }), isCheckout);
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach(buf => buf.lock());
    const node = snapshot(document, {
      mirror,
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskTextFn,
      maskInputFn,
      slimDOM: slimDOMOptions,
      dataURLOptions,
      recordCanvas,
      inlineImages,
      onSerialize: n => {
        if (isSerializedIframe(n, mirror)) {
          iframeManager.addIframe(n);
        }
        if (isSerializedStylesheet(n, mirror)) {
          stylesheetManager.trackLinkElement(n);
        }
        if (hasShadowRoot(n)) {
          shadowDomManager.addShadowRoot(n.shadowRoot, document);
        }
      },
      onIframeLoad: (iframe, childSn) => {
        iframeManager.attachIframe(iframe, childSn);
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: (linkEl, childSn) => {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      keepIframeSrcFn
    });
    if (!node) {
      return console.warn('Failed to snapshot the document');
    }
    wrappedEmit(wrapEvent({
      type: EventType.FullSnapshot,
      data: {
        node,
        initialOffset: getWindowScroll(window)
      }
    }), isCheckout);
    mutationBuffers.forEach(buf => buf.unlock());
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
  };
  try {
    const handlers = [];
    const observe = doc => {
      var _a;
      return callbackWrapper(initObservers)({
        mutationCb: wrappedMutationEmit,
        mousemoveCb: (positions, source) => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: {
            source,
            positions
          }
        })),
        mouseInteractionCb: d => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.MouseInteraction
          }, d)
        })),
        scrollCb: wrappedScrollEmit,
        viewportResizeCb: d => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.ViewportResize
          }, d)
        })),
        inputCb: v => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.Input
          }, v)
        })),
        mediaInteractionCb: p => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.MediaInteraction
          }, p)
        })),
        styleSheetRuleCb: r => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.StyleSheetRule
          }, r)
        })),
        styleDeclarationCb: r => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.StyleDeclaration
          }, r)
        })),
        canvasMutationCb: wrappedCanvasMutationEmit,
        fontCb: p => wrappedEmit(wrapEvent({
          type: EventType.IncrementalSnapshot,
          data: Object.assign({
            source: IncrementalSource.Font
          }, p)
        })),
        selectionCb: p => {
          wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.Selection
            }, p)
          }));
        },
        blockClass,
        ignoreClass,
        ignoreSelector,
        maskTextClass,
        maskTextSelector,
        maskInputOptions,
        inlineStylesheet,
        sampling,
        recordDOM,
        recordCanvas,
        inlineImages,
        userTriggeredOnInput,
        collectFonts,
        doc,
        maskInputFn,
        maskTextFn,
        keepIframeSrcFn,
        blockSelector,
        slimDOMOptions,
        dataURLOptions,
        mirror,
        iframeManager,
        stylesheetManager,
        shadowDomManager,
        processedNodeManager,
        canvasManager,
        ignoreCSSAttributes,
        plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter(p => p.observer)) === null || _a === void 0 ? void 0 : _a.map(p => ({
          observer: p.observer,
          options: p.options,
          callback: payload => wrappedEmit(wrapEvent({
            type: EventType.Plugin,
            data: {
              plugin: p.name,
              payload
            }
          }))
        }))) || []
      }, hooks);
    };
    iframeManager.addLoadListener(iframeEl => {
      try {
        handlers.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });
    const init = () => {
      takeFullSnapshot();
      handlers.push(observe(document));
      recording = true;
    };
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      init();
    } else {
      handlers.push(on('DOMContentLoaded', () => {
        wrappedEmit(wrapEvent({
          type: EventType.DomContentLoaded,
          data: {}
        }));
        if (recordAfter === 'DOMContentLoaded') init();
      }));
      handlers.push(on('load', () => {
        wrappedEmit(wrapEvent({
          type: EventType.Load,
          data: {}
        }));
        if (recordAfter === 'load') init();
      }, window));
    }
    return () => {
      handlers.forEach(h => h());
      processedNodeManager.destroy();
      recording = false;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}
record.addCustomEvent = (tag, payload) => {
  if (!recording) {
    throw new Error('please add custom event after start recording');
  }
  wrappedEmit(wrapEvent({
    type: EventType.Custom,
    data: {
      tag,
      payload
    }
  }));
};
record.freezePage = () => {
  mutationBuffers.forEach(buf => buf.freeze());
};
record.takeFullSnapshot = isCheckout => {
  if (!recording) {
    throw new Error('please take full snapshot after start recording');
  }
  takeFullSnapshot(isCheckout);
};
record.mirror = mirror;

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array,
  u16 = Uint16Array,
  u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */0, 0, /* impossible */0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function freb(eb, start) {
  var b = new u16(31);
  for (var i = 0; i < 31; ++i) {
    b[i] = start += 1 << eb[i - 1];
  }
  // numbers here are at max 18 bits
  var r = new u32(b[30]);
  for (var i = 1; i < 30; ++i) {
    for (var j = b[i]; j < b[i + 1]; ++j) {
      r[j] = j - b[i] << 5 | i;
    }
  }
  return [b, r];
};
var _a = freb(fleb, 2),
  fl = _a[0],
  revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0),
  revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
  // reverse table algorithm from SO
  var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
  x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
  x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
  rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function hMap(cd, mb, r) {
  var s = cd.length;
  // index
  var i = 0;
  // u16 "map": index -> # of codes with bit length = index
  var l = new u16(mb);
  // length of cd must be 288 (total # of codes)
  for (; i < s; ++i) ++l[cd[i] - 1];
  // u16 "map": index -> minimum code for bit length = index
  var le = new u16(mb);
  for (i = 0; i < mb; ++i) {
    le[i] = le[i - 1] + l[i - 1] << 1;
  }
  var co;
  if (r) {
    // u16 "map": index -> number of actual bits, symbol for code
    co = new u16(1 << mb);
    // bits to remove for reverser
    var rvb = 15 - mb;
    for (i = 0; i < s; ++i) {
      // ignore 0 lengths
      if (cd[i]) {
        // num encoding both symbol and bits read
        var sv = i << 4 | cd[i];
        // free bits
        var r_1 = mb - cd[i];
        // start value
        var v = le[cd[i] - 1]++ << r_1;
        // m is end value
        for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
          // every 16 bit value starting with the code yields the same result
          co[rev[v] >>> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s);
    for (i = 0; i < s; ++i) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
  }
  return co;
};
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i) flt[i] = 8;
for (var i = 144; i < 256; ++i) flt[i] = 9;
for (var i = 256; i < 280; ++i) flt[i] = 7;
for (var i = 280; i < 288; ++i) flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i) fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/hMap(flt, 9, 0);
// fixed distance map
var fdm = /*#__PURE__*/hMap(fdt, 5, 0);
// get end of byte
var shft = function shft(p) {
  return (p / 8 >> 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function slc(v, s, e) {
  if (s == null || s < 0) s = 0;
  if (e == null || e > v.length) e = v.length;
  // can't use .constructor in case user-supplied
  var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
  n.set(v.subarray(s, e));
  return n;
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function wbits(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function wbits16(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
  d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function hTree(d, mb) {
  // Need extra info to make a tree
  var t = [];
  for (var i = 0; i < d.length; ++i) {
    if (d[i]) t.push({
      s: i,
      f: d[i]
    });
  }
  var s = t.length;
  var t2 = t.slice();
  if (!s) return [new u8(0), 0];
  if (s == 1) {
    var v = new u8(t[0].s + 1);
    v[t[0].s] = 1;
    return [v, 1];
  }
  t.sort(function (a, b) {
    return a.f - b.f;
  });
  // after i2 reaches last ind, will be stopped
  // freq must be greater than largest possible number of symbols
  t.push({
    s: -1,
    f: 25001
  });
  var l = t[0],
    r = t[1],
    i0 = 0,
    i1 = 1,
    i2 = 2;
  t[0] = {
    s: -1,
    f: l.f + r.f,
    l: l,
    r: r
  };
  // efficient algorithm from UZIP.js
  // i0 is lookbehind, i2 is lookahead - after processing two low-freq
  // symbols that combined have high freq, will start processing i2 (high-freq,
  // non-composite) symbols instead
  // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
  while (i1 != s - 1) {
    l = t[t[i0].f < t[i2].f ? i0++ : i2++];
    r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
    t[i1++] = {
      s: -1,
      f: l.f + r.f,
      l: l,
      r: r
    };
  }
  var maxSym = t2[0].s;
  for (var i = 1; i < s; ++i) {
    if (t2[i].s > maxSym) maxSym = t2[i].s;
  }
  // code lengths
  var tr = new u16(maxSym + 1);
  // max bits in tree
  var mbt = ln(t[i1 - 1], tr, 0);
  if (mbt > mb) {
    // more algorithms from UZIP.js
    // TODO: find out how this code works (debt)
    //  ind    debt
    var i = 0,
      dt = 0;
    //    left            cost
    var lft = mbt - mb,
      cst = 1 << lft;
    t2.sort(function (a, b) {
      return tr[b.s] - tr[a.s] || a.f - b.f;
    });
    for (; i < s; ++i) {
      var i2_1 = t2[i].s;
      if (tr[i2_1] > mb) {
        dt += cst - (1 << mbt - tr[i2_1]);
        tr[i2_1] = mb;
      } else break;
    }
    dt >>>= lft;
    while (dt > 0) {
      var i2_2 = t2[i].s;
      if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;else ++i;
    }
    for (; i >= 0 && dt; --i) {
      var i2_3 = t2[i].s;
      if (tr[i2_3] == mb) {
        --tr[i2_3];
        ++dt;
      }
    }
    mbt = mb;
  }
  return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function ln(n, l, d) {
  return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function lc(c) {
  var s = c.length;
  // Note that the semicolon was intentional
  while (s && !c[--s]);
  var cl = new u16(++s);
  //  ind      num         streak
  var cli = 0,
    cln = c[0],
    cls = 1;
  var w = function w(v) {
    cl[cli++] = v;
  };
  for (var i = 1; i <= s; ++i) {
    if (c[i] == cln && i != s) ++cls;else {
      if (!cln && cls > 2) {
        for (; cls > 138; cls -= 138) w(32754);
        if (cls > 2) {
          w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
          cls = 0;
        }
      } else if (cls > 3) {
        w(cln), --cls;
        for (; cls > 6; cls -= 6) w(8304);
        if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
      }
      while (cls--) w(cln);
      cls = 1;
      cln = c[i];
    }
  }
  return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function clen(cf, cl) {
  var l = 0;
  for (var i = 0; i < cl.length; ++i) l += cf[i] * cl[i];
  return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function wfblk(out, pos, dat) {
  // no need to write 00 as type: TypedArray defaults to 0
  var s = dat.length;
  var o = shft(pos + 2);
  out[o] = s & 255;
  out[o + 1] = s >>> 8;
  out[o + 2] = out[o] ^ 255;
  out[o + 3] = out[o + 1] ^ 255;
  for (var i = 0; i < s; ++i) out[o + i + 4] = dat[i];
  return (o + 4 + s) * 8;
};
// writes a block
var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
  wbits(out, p++, final);
  ++lf[256];
  var _a = hTree(lf, 15),
    dlt = _a[0],
    mlb = _a[1];
  var _b = hTree(df, 15),
    ddt = _b[0],
    mdb = _b[1];
  var _c = lc(dlt),
    lclt = _c[0],
    nlc = _c[1];
  var _d = lc(ddt),
    lcdt = _d[0],
    ndc = _d[1];
  var lcfreq = new u16(19);
  for (var i = 0; i < lclt.length; ++i) lcfreq[lclt[i] & 31]++;
  for (var i = 0; i < lcdt.length; ++i) lcfreq[lcdt[i] & 31]++;
  var _e = hTree(lcfreq, 7),
    lct = _e[0],
    mlcb = _e[1];
  var nlcc = 19;
  for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
  var flen = bl + 5 << 3;
  var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
  var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
  if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
  var lm, ll, dm, dl;
  wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
  if (dtlen < ftlen) {
    lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
    var llm = hMap(lct, mlcb, 0);
    wbits(out, p, nlc - 257);
    wbits(out, p + 5, ndc - 1);
    wbits(out, p + 10, nlcc - 4);
    p += 14;
    for (var i = 0; i < nlcc; ++i) wbits(out, p + 3 * i, lct[clim[i]]);
    p += 3 * nlcc;
    var lcts = [lclt, lcdt];
    for (var it = 0; it < 2; ++it) {
      var clct = lcts[it];
      for (var i = 0; i < clct.length; ++i) {
        var len = clct[i] & 31;
        wbits(out, p, llm[len]), p += lct[len];
        if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
      }
    }
  } else {
    lm = flm, ll = flt, dm = fdm, dl = fdt;
  }
  for (var i = 0; i < li; ++i) {
    if (syms[i] > 255) {
      var len = syms[i] >>> 18 & 31;
      wbits16(out, p, lm[len + 257]), p += ll[len + 257];
      if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
      var dst = syms[i] & 31;
      wbits16(out, p, dm[dst]), p += dl[dst];
      if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else {
      wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    }
  }
  wbits16(out, p, lm[256]);
  return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
  var s = dat.length;
  var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
  // writing to this writes to the output buffer
  var w = o.subarray(pre, o.length - post);
  var pos = 0;
  if (!lvl || s < 8) {
    for (var i = 0; i <= s; i += 65535) {
      // end
      var e = i + 65535;
      if (e < s) {
        // write full block
        pos = wfblk(w, pos, dat.subarray(i, e));
      } else {
        // write final block
        w[i] = lst;
        pos = wfblk(w, pos, dat.subarray(i, s));
      }
    }
  } else {
    var opt = deo[lvl - 1];
    var n = opt >>> 13,
      c = opt & 8191;
    var msk_1 = (1 << plvl) - 1;
    //    prev 2-byte val map    curr 2-byte val map
    var prev = new u16(32768),
      head = new u16(msk_1 + 1);
    var bs1_1 = Math.ceil(plvl / 3),
      bs2_1 = 2 * bs1_1;
    var hsh = function hsh(i) {
      return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
    };
    // 24576 is an arbitrary number of maximum symbols per block
    // 424 buffer for last block
    var syms = new u32(25000);
    // length/literal freq   distance freq
    var lf = new u16(288),
      df = new u16(32);
    //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
    var lc_1 = 0,
      eb = 0,
      i = 0,
      li = 0,
      wi = 0,
      bs = 0;
    for (; i < s; ++i) {
      // hash value
      var hv = hsh(i);
      // index mod 32768
      var imod = i & 32767;
      // previous index with this value
      var pimod = head[hv];
      prev[imod] = pimod;
      head[hv] = imod;
      // We always should modify head and prev, but only add symbols if
      // this data is not yet processed ("wait" for wait index)
      if (wi <= i) {
        // bytes remaining
        var rem = s - i;
        if ((lc_1 > 7000 || li > 24576) && rem > 423) {
          pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
          li = lc_1 = eb = 0, bs = i;
          for (var j = 0; j < 286; ++j) lf[j] = 0;
          for (var j = 0; j < 30; ++j) df[j] = 0;
        }
        //  len    dist   chain
        var l = 2,
          d = 0,
          ch_1 = c,
          dif = imod - pimod & 32767;
        if (rem > 2 && hv == hsh(i - dif)) {
          var maxn = Math.min(n, rem) - 1;
          var maxd = Math.min(32767, i);
          // max possible length
          // not capped at dif because decompressors implement "rolling" index population
          var ml = Math.min(258, rem);
          while (dif <= maxd && --ch_1 && imod != pimod) {
            if (dat[i + l] == dat[i + l - dif]) {
              var nl = 0;
              for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
              if (nl > l) {
                l = nl, d = dif;
                // break out early when we reach "nice" (we are satisfied enough)
                if (nl > maxn) break;
                // now, find the rarest 2-byte sequence within this
                // length of literals and search for that instead.
                // Much faster than just using the start
                var mmd = Math.min(dif, nl - 2);
                var md = 0;
                for (var j = 0; j < mmd; ++j) {
                  var ti = i - dif + j + 32768 & 32767;
                  var pti = prev[ti];
                  var cd = ti - pti + 32768 & 32767;
                  if (cd > md) md = cd, pimod = ti;
                }
              }
            }
            // check the previous match
            imod = pimod, pimod = prev[imod];
            dif += imod - pimod + 32768 & 32767;
          }
        }
        // d will be nonzero only when a match was found
        if (d) {
          // store both dist and len data in one Uint32
          // Make sure this is recognized as a len/dist with 28th bit (2^28)
          syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
          var lin = revfl[l] & 31,
            din = revfd[d] & 31;
          eb += fleb[lin] + fdeb[din];
          ++lf[257 + lin];
          ++df[din];
          wi = i + l;
          ++lc_1;
        } else {
          syms[li++] = dat[i];
          ++lf[dat[i]];
        }
      }
    }
    pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
    // this is the easiest way to avoid needing to maintain state
    if (!lst) pos = wfblk(w, pos, et);
  }
  return slc(o, 0, pre + shft(pos) + post);
};
// Alder32
var adler = function adler() {
  var a = 1,
    b = 0;
  return {
    p: function (d) {
      // closures have awful performance
      var n = a,
        m = b;
      var l = d.length;
      for (var i = 0; i != l;) {
        var e = Math.min(i + 5552, l);
        for (; i < e; ++i) n += d[i], m += n;
        n %= 65521, m %= 65521;
      }
      a = n, b = m;
    },
    d: function () {
      return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
    }
  };
};
// deflate with opts
var dopt = function dopt(dat, opt, pre, post, st) {
  return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// write bytes
var wbytes = function wbytes(d, b, v) {
  for (; v; ++b) d[b] = v, v >>>= 8;
};
// zlib header
var zlh = function zlh(c, o) {
  var lv = o.level,
    fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
  c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var a = adler();
  a.p(data);
  var d = dopt(data, opts, 2, 4);
  return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
  var l = str.length;
  if (!latin1 && typeof TextEncoder != 'undefined') return new TextEncoder().encode(str);
  var ar = new u8(str.length + (str.length >>> 1));
  var ai = 0;
  var w = function w(v) {
    ar[ai++] = v;
  };
  for (var i = 0; i < l; ++i) {
    if (ai + 5 > ar.length) {
      var n = new u8(ai + 8 + (l - i << 1));
      n.set(ar);
      ar = n;
    }
    var c = str.charCodeAt(i);
    if (c < 128 || latin1) w(c);else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);else if (c > 55295 && c < 57344) c = 65536 + (c & 1023 << 10) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
  }
  return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
  var r = '';
  if (!latin1 && typeof TextDecoder != 'undefined') return new TextDecoder().decode(dat);
  for (var i = 0; i < dat.length;) {
    var c = dat[i++];
    if (c < 128 || latin1) r += String.fromCharCode(c);else if (c < 224) r += String.fromCharCode((c & 31) << 6 | dat[i++] & 63);else if (c < 240) r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63);else c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
  }
  return r;
}
const MARK = 'v1';
const pack = event => {
  const _e = Object.assign(Object.assign({}, event), {
    v: MARK
  });
  return strFromU8(zlibSync(strToU8(JSON.stringify(_e))), true);
};
const instanceOfAny = (object, constructors) => constructors.some(c => object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}
const transactionDoneMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
  const promise = new Promise((resolve, reject) => {
    const unlisten = () => {
      request.removeEventListener('success', success);
      request.removeEventListener('error', error);
    };
    const success = () => {
      resolve(wrap(request.result));
      unlisten();
    };
    const error = () => {
      reject(request.error);
      unlisten();
    };
    request.addEventListener('success', success);
    request.addEventListener('error', error);
  });
  // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
  // is because we create many promises from a single IDBRequest.
  reverseTransformCache.set(promise, request);
  return promise;
}
function cacheDonePromiseForTransaction(tx) {
  // Early bail if we've already created a done promise for this transaction.
  if (transactionDoneMap.has(tx)) return;
  const done = new Promise((resolve, reject) => {
    const unlisten = () => {
      tx.removeEventListener('complete', complete);
      tx.removeEventListener('error', error);
      tx.removeEventListener('abort', error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject(tx.error || new DOMException('AbortError', 'AbortError'));
      unlisten();
    };
    tx.addEventListener('complete', complete);
    tx.addEventListener('error', error);
    tx.addEventListener('abort', error);
  });
  // Cache it for later retrieval.
  transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
  get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      // Special handling for transaction.done.
      if (prop === 'done') return transactionDoneMap.get(target);
      // Make tx.store return the only store in the transaction, or undefined if there are many.
      if (prop === 'store') {
        return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    // Else transform whatever we get back.
    return wrap(target[prop]);
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has(target, prop) {
    if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
      return true;
    }
    return prop in target;
  }
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  // Due to expected object equality (which is enforced by the caching in `wrap`), we
  // only create one new func per func.
  // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
  // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
  // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
  // with real promises, so each advance methods returns a new promise for the cursor object, or
  // undefined if the end of the cursor has been reached.
  if (getCursorAdvanceMethods().includes(func)) {
    return function (...args) {
      // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
      // the original object.
      func.apply(unwrap(this), args);
      return wrap(this.request);
    };
  }
  return function (...args) {
    // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
    // the original object.
    return wrap(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === 'function') return wrapFunction(value);
  // This doesn't return, it just creates a 'done' promise for the transaction,
  // which is later returned for transaction.done (see idbObjectHandler).
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
  // Return the same value back if we're not going to transform it.
  return value;
}
function wrap(value) {
  // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
  // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
  if (value instanceof IDBRequest) return promisifyRequest(value);
  // If we've already transformed this value before, reuse the transformed value.
  // This is faster, but it also provides object equality.
  if (transformCache.has(value)) return transformCache.get(value);
  const newValue = transformCachableValue(value);
  // Not all types are transformed.
  // These may be primitive types, so they can't be WeakMap keys.
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
const unwrap = value => reverseTransformCache.get(value);

/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, {
  blocked,
  upgrade,
  blocking,
  terminated
} = {}) {
  const request = indexedDB.open(name, version);
  const openPromise = wrap(request);
  if (upgrade) {
    request.addEventListener('upgradeneeded', event => {
      upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
    });
  }
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event.newVersion, event));
  }
  openPromise.then(db => {
    if (terminated) db.addEventListener('close', () => terminated());
    if (blocking) {
      db.addEventListener('versionchange', event => blocking(event.oldVersion, event.newVersion, event));
    }
  }).catch(() => {});
  return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, {
  blocked
} = {}) {
  const request = indexedDB.deleteDatabase(name);
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event));
  }
  return wrap(request).then(() => undefined);
}
const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
    return;
  }
  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  const targetFuncName = prop.replace(/FromIndex$/, '');
  const useIndex = prop !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
  // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
  !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }
  const method = async function method(storeName, ...args) {
    // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
    const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
    let target = tx.store;
    if (useIndex) target = target.index(args.shift());
    // Must reject if op rejects.
    // If it's a write operation, must reject if tx.done rejects.
    // Must reject with op rejection first.
    // Must resolve with op value.
    // Must handle both promises (no unhandled rejections)
    return (await Promise.all([target[targetFuncName](...args), isWrite && tx.done]))[0];
  };
  cachedMethods.set(prop, method);
  return method;
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
  has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));
const advanceMethodProps = ['continue', 'continuePrimaryKey', 'advance'];
const methodMap = {};
const advanceResults = new WeakMap();
const ittrProxiedCursorToOriginalProxy = new WeakMap();
const cursorIteratorTraps = {
  get(target, prop) {
    if (!advanceMethodProps.includes(prop)) return target[prop];
    let cachedFunc = methodMap[prop];
    if (!cachedFunc) {
      cachedFunc = methodMap[prop] = function (...args) {
        advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
      };
    }
    return cachedFunc;
  }
};
async function* iterate(...args) {
  // tslint:disable-next-line:no-this-assignment
  let cursor = this;
  if (!(cursor instanceof IDBCursor)) {
    cursor = await cursor.openCursor(...args);
  }
  if (!cursor) return;
  cursor = cursor;
  const proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
  ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
  // Map this double-proxy back to the original, so other cursor methods work.
  reverseTransformCache.set(proxiedCursor, unwrap(cursor));
  while (cursor) {
    yield proxiedCursor;
    // If one of the advancing methods was not called, call continue().
    cursor = await (advanceResults.get(proxiedCursor) || cursor.continue());
    advanceResults.delete(proxiedCursor);
  }
}
function isIteratorProp(target, prop) {
  return prop === Symbol.asyncIterator && instanceOfAny(target, [IDBIndex, IDBObjectStore, IDBCursor]) || prop === 'iterate' && instanceOfAny(target, [IDBIndex, IDBObjectStore]);
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get(target, prop, receiver) {
    if (isIteratorProp(target, prop)) return iterate;
    return oldTraps.get(target, prop, receiver);
  },
  has(target, prop) {
    return isIteratorProp(target, prop) || oldTraps.has(target, prop);
  }
}));
var MAX_IDB_STORAGE_TIME = 1000 * 60 * 60 * 24 * 3; // 3 days
var openOrCreateRemoteConfigStore = function openOrCreateRemoteConfigStore(dbName, configKeys) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, openDB(dbName, 1, {
            upgrade: function (db) {
              configKeys.forEach(function (key) {
                if (!db.objectStoreNames.contains(key)) {
                  db.createObjectStore(key);
                }
              });
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var openOrCreateMetaStore = function openOrCreateMetaStore(dbName) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, openDB(dbName, 1, {
            upgrade: function (db) {
              if (!db.objectStoreNames.contains('lastFetchedSessionId')) {
                db.createObjectStore('lastFetchedSessionId');
              }
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var createRemoteConfigIDBStore = function createRemoteConfigIDBStore(_a) {
  var loggerProvider = _a.loggerProvider,
    apiKey = _a.apiKey,
    configKeys = _a.configKeys;
  return __awaiter$1(void 0, void 0, void 0, function () {
    var remoteConfigDBName, remoteConfigDB, metaDBName, metaDB, lastFetchedSessionId, e_1, storeRemoteConfig, getLastFetchedSessionId, getRemoteConfig, remoteConfigHasValues;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          remoteConfigDBName = "".concat(apiKey.substring(0, 10), "_amp_config");
          return [4 /*yield*/, openOrCreateRemoteConfigStore(remoteConfigDBName, configKeys)];
        case 1:
          remoteConfigDB = _b.sent();
          metaDBName = "".concat(apiKey.substring(0, 10), "_amp_config_meta");
          return [4 /*yield*/, openOrCreateMetaStore(metaDBName)];
        case 2:
          metaDB = _b.sent();
          _b.label = 3;
        case 3:
          _b.trys.push([3, 8,, 9]);
          return [4 /*yield*/, metaDB.get('lastFetchedSessionId', 'sessionId')];
        case 4:
          lastFetchedSessionId = _b.sent();
          if (!(lastFetchedSessionId && Date.now() - lastFetchedSessionId >= MAX_IDB_STORAGE_TIME)) return [3 /*break*/, 7];
          remoteConfigDB.close();
          return [4 /*yield*/, deleteDB(remoteConfigDBName)];
        case 5:
          _b.sent();
          return [4 /*yield*/, openOrCreateRemoteConfigStore(apiKey, configKeys)];
        case 6:
          remoteConfigDB = _b.sent();
          _b.label = 7;
        case 7:
          return [3 /*break*/, 9];
        case 8:
          e_1 = _b.sent();
          loggerProvider.warn("Failed to reset store: ".concat(e_1));
          return [3 /*break*/, 9];
        case 9:
          storeRemoteConfig = function (remoteConfig, sessionId) {
            return __awaiter$1(void 0, void 0, void 0, function () {
              var _loop_1, _a, _b, _c, _i, configNamespace, e_2;
              return __generator(this, function (_d) {
                switch (_d.label) {
                  case 0:
                    _d.trys.push([0, 7,, 8]);
                    if (!sessionId) return [3 /*break*/, 2];
                    return [4 /*yield*/, metaDB.put('lastFetchedSessionId', sessionId, 'sessionId')];
                  case 1:
                    _d.sent();
                    _d.label = 2;
                  case 2:
                    _loop_1 = function (configNamespace) {
                      var config, tx;
                      return __generator(this, function (_e) {
                        switch (_e.label) {
                          case 0:
                            config = remoteConfig.configs[configNamespace];
                            tx = remoteConfigDB.transaction(configNamespace, 'readwrite');
                            return [4 /*yield*/, Promise.all(__spreadArray(__spreadArray([], __read(Object.keys(config).map(function (key) {
                              return tx.store.put(_assign$({}, config[key]), key);
                            })), false), [tx.done], false))];
                          case 1:
                            _e.sent();
                            return [2 /*return*/];
                        }
                      });
                    };
                    _a = remoteConfig.configs;
                    _b = [];
                    for (_c in _a) _b.push(_c);
                    _i = 0;
                    _d.label = 3;
                  case 3:
                    if (!(_i < _b.length)) return [3 /*break*/, 6];
                    _c = _b[_i];
                    if (!(_c in _a)) return [3 /*break*/, 5];
                    configNamespace = _c;
                    return [5 /*yield**/, _loop_1(configNamespace)];
                  case 4:
                    _d.sent();
                    _d.label = 5;
                  case 5:
                    _i++;
                    return [3 /*break*/, 3];
                  case 6:
                    return [3 /*break*/, 8];
                  case 7:
                    e_2 = _d.sent();
                    loggerProvider.warn("Failed to store remote config: ".concat(e_2));
                    return [3 /*break*/, 8];
                  case 8:
                    return [2 /*return*/];
                }
              });
            });
          };
          getLastFetchedSessionId = function () {
            return __awaiter$1(void 0, void 0, void 0, function () {
              var lastFetchedSessionId, e_3;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);
                    return [4 /*yield*/, metaDB.get('lastFetchedSessionId', 'sessionId')];
                  case 1:
                    lastFetchedSessionId = _a.sent();
                    return [2 /*return*/, lastFetchedSessionId];
                  case 2:
                    e_3 = _a.sent();
                    loggerProvider.warn("Failed to fetch lastFetchedSessionId: ".concat(e_3));
                    return [3 /*break*/, 3];
                  case 3:
                    return [2 /*return*/, undefined];
                }
              });
            });
          };
          getRemoteConfig = function (configNamespace, key) {
            return __awaiter$1(void 0, void 0, void 0, function () {
              var config, e_4;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);
                    return [4 /*yield*/, remoteConfigDB.get(configNamespace, key)];
                  case 1:
                    config = _a.sent();
                    return [2 /*return*/, config];
                  case 2:
                    e_4 = _a.sent();
                    loggerProvider.warn("Failed to fetch remote config: ".concat(e_4));
                    return [3 /*break*/, 3];
                  case 3:
                    return [2 /*return*/, undefined];
                }
              });
            });
          };
          remoteConfigHasValues = function (configNamespace) {
            return __awaiter$1(void 0, void 0, void 0, function () {
              var config, e_5;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);
                    return [4 /*yield*/, remoteConfigDB.getAll(configNamespace)];
                  case 1:
                    config = _a.sent();
                    return [2 /*return*/, !!config.length];
                  case 2:
                    e_5 = _a.sent();
                    loggerProvider.warn("Failed to fetch remote config: ".concat(e_5));
                    return [3 /*break*/, 3];
                  case 3:
                    return [2 /*return*/, false];
                }
              });
            });
          };
          return [2 /*return*/, {
            storeRemoteConfig: storeRemoteConfig,
            getRemoteConfig: getRemoteConfig,
            getLastFetchedSessionId: getLastFetchedSessionId,
            remoteConfigHasValues: remoteConfigHasValues
          }];
      }
    });
  });
};
var UNEXPECTED_NETWORK_ERROR_MESSAGE$1 = 'Network error occurred, remote config fetch failed';
var SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var MAX_RETRIES_EXCEEDED_MESSAGE$1 = 'Remote config fetch rejected due to exceeded retry count';
var TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var UNEXPECTED_ERROR_MESSAGE$1 = 'Unexpected error occurred';
var REMOTE_CONFIG_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_STAGING = 'https://sr-client-cfg.stag2.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_EU = 'https://sr-client-cfg.eu.amplitude.com/config';
var RemoteConfigFetch = /** @class */function () {
  function RemoteConfigFetch(_a) {
    var localConfig = _a.localConfig,
      configKeys = _a.configKeys;
    var _this = this;
    this.retryTimeout = 1000;
    this.attempts = 0;
    this.sessionTargetingMatch = false;
    // Time used to fetch remote config in milliseconds
    this.fetchTime = 0;
    this.getRemoteConfig = function (configNamespace, key, sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var fetchStartTime, remoteConfigHasValues, lastFetchedSessionId, idbRemoteConfig, configAPIResponse, remoteConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              fetchStartTime = Date.now();
              if (!this.remoteConfigIDBStore) return [3 /*break*/, 4];
              return [4 /*yield*/, this.remoteConfigIDBStore.remoteConfigHasValues(configNamespace)];
            case 1:
              remoteConfigHasValues = _a.sent();
              return [4 /*yield*/, this.remoteConfigIDBStore.getLastFetchedSessionId()];
            case 2:
              lastFetchedSessionId = _a.sent();
              if (!(remoteConfigHasValues && lastFetchedSessionId === sessionId)) return [3 /*break*/, 4];
              return [4 /*yield*/, this.remoteConfigIDBStore.getRemoteConfig(configNamespace, key)];
            case 3:
              idbRemoteConfig = _a.sent();
              this.fetchTime = Date.now() - fetchStartTime;
              return [2 /*return*/, idbRemoteConfig];
            case 4:
              return [4 /*yield*/, this.fetchWithTimeout(sessionId)];
            case 5:
              configAPIResponse = _a.sent();
              if (configAPIResponse) {
                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                if (remoteConfig) {
                  this.fetchTime = Date.now() - fetchStartTime;
                  return [2 /*return*/, remoteConfig[key]];
                }
              }
              this.fetchTime = Date.now() - fetchStartTime;
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.fetchWithTimeout = function (sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var controller, timeoutId, remoteConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              controller = new AbortController();
              timeoutId = setTimeout(function () {
                return controller.abort();
              }, 5000);
              return [4 /*yield*/, this.fetchRemoteConfig(controller.signal, sessionId)];
            case 1:
              remoteConfig = _a.sent();
              clearTimeout(timeoutId);
              return [2 /*return*/, remoteConfig];
          }
        });
      });
    };
    this.fetchRemoteConfig = function (signal, sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var urlParams, options, serverUrl, res, parsedStatus, e_1, knownError;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                return [2 /*return*/, this.completeRequest({
                  err: MAX_RETRIES_EXCEEDED_MESSAGE$1
                })];
              } else if (signal.aborted) {
                return [2 /*return*/, this.completeRequest({
                  err: TIMEOUT_MESSAGE
                })];
              } else if (sessionId !== this.lastFetchedSessionId) {
                this.lastFetchedSessionId = sessionId;
                this.attempts = 0;
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              urlParams = new URLSearchParams({
                api_key: this.localConfig.apiKey,
                config_keys: this.configKeys.join(',')
              });
              options = {
                headers: {
                  'Content-Type': 'application/json',
                  Accept: '*/*'
                },
                method: 'GET'
              };
              serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
              this.attempts += 1;
              return [4 /*yield*/, fetch(serverUrl, _assign$(_assign$({}, options), {
                signal: signal
              }))];
            case 2:
              res = _a.sent();
              if (res === null) {
                return [2 /*return*/, this.completeRequest({
                  err: UNEXPECTED_ERROR_MESSAGE$1
                })];
              }
              parsedStatus = new BaseTransport().buildStatus(res.status);
              switch (parsedStatus) {
                case Status.Success:
                  return [2 /*return*/, this.parseAndStoreConfig(res, sessionId)];
                case Status.Failed:
                  return [2 /*return*/, this.retryFetch(signal, sessionId)];
                default:
                  return [2 /*return*/, this.completeRequest({
                    err: UNEXPECTED_NETWORK_ERROR_MESSAGE$1
                  })];
              }
            case 3:
              e_1 = _a.sent();
              knownError = e_1;
              if (signal.aborted) {
                return [2 /*return*/, this.completeRequest({
                  err: TIMEOUT_MESSAGE
                })];
              }
              return [2 /*return*/, this.completeRequest({
                err: knownError.message
              })];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    this.retryFetch = function (signal, sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, new Promise(function (resolve) {
                return setTimeout(resolve, _this.attempts * _this.retryTimeout);
              })];
            case 1:
              _a.sent();
              return [2 /*return*/, this.fetchRemoteConfig(signal, sessionId)];
          }
        });
      });
    };
    this.parseAndStoreConfig = function (res, sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var remoteConfig, _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, res.json()];
            case 1:
              remoteConfig = _b.sent();
              _a = this.remoteConfigIDBStore;
              if (!_a) return [3 /*break*/, 3];
              return [4 /*yield*/, this.remoteConfigIDBStore.storeRemoteConfig(remoteConfig, sessionId)];
            case 2:
              _a = _b.sent();
              _b.label = 3;
            case 3:
              this.completeRequest({
                success: SUCCESS_REMOTE_CONFIG
              });
              return [2 /*return*/, remoteConfig];
          }
        });
      });
    };
    this.localConfig = localConfig;
    this.configKeys = configKeys;
  }
  RemoteConfigFetch.prototype.initialize = function () {
    return __awaiter$1(this, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this;
            return [4 /*yield*/, createRemoteConfigIDBStore({
              apiKey: this.localConfig.apiKey,
              loggerProvider: this.localConfig.loggerProvider,
              configKeys: this.configKeys
            })];
          case 1:
            _a.remoteConfigIDBStore = _b.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  RemoteConfigFetch.prototype.getServerUrl = function () {
    if (this.localConfig.serverZone === ServerZone.STAGING) {
      return REMOTE_CONFIG_SERVER_URL_STAGING;
    }
    if (this.localConfig.serverZone === ServerZone.EU) {
      return REMOTE_CONFIG_SERVER_URL_EU;
    }
    return REMOTE_CONFIG_SERVER_URL;
  };
  RemoteConfigFetch.prototype.completeRequest = function (_a) {
    var err = _a.err,
      success = _a.success;
    if (err) {
      throw new Error(err);
    } else if (success) {
      this.localConfig.loggerProvider.log(success);
    }
  };
  return RemoteConfigFetch;
}();
var createRemoteConfigFetch$1 = function createRemoteConfigFetch$1(_a) {
  var localConfig = _a.localConfig,
    configKeys = _a.configKeys;
  return __awaiter$1(void 0, void 0, void 0, function () {
    var remoteConfigFetch;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          remoteConfigFetch = new RemoteConfigFetch({
            localConfig: localConfig,
            configKeys: configKeys
          });
          return [4 /*yield*/, remoteConfigFetch.initialize()];
        case 1:
          _b.sent();
          return [2 /*return*/, remoteConfigFetch];
      }
    });
  });
};
var createRemoteConfigFetch = createRemoteConfigFetch$1;
var SessionReplayJoinedConfigGenerator = /** @class */function () {
  function SessionReplayJoinedConfigGenerator(apiKey, options) {
    this.localConfig = new SessionReplayLocalConfig(apiKey, options);
  }
  SessionReplayJoinedConfigGenerator.prototype.initialize = function () {
    return __awaiter$1(this, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this;
            return [4 /*yield*/, createRemoteConfigFetch({
              localConfig: this.localConfig,
              configKeys: ['sessionReplay']
            })];
          case 1:
            _a.remoteConfigFetch = _b.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayJoinedConfigGenerator.prototype.generateJoinedConfig = function (sessionId) {
    var _a, _b, _c;
    return __awaiter$1(this, void 0, void 0, function () {
      var config, remoteConfig, samplingConfig_1, privacyConfig, _d, err_1, knownError, samplingConfig, remotePrivacyConfig, localPrivacyConfig, joinedPrivacyConfig, privacyConfigSelectorMap, selectorMap, _e, _f, _g, selector, selectorType;
      var e_1, _h;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            config = _assign$({}, this.localConfig);
            // Special case here as optOut is implemented via getter/setter
            config.optOut = this.localConfig.optOut;
            // We always want captureEnabled to be true, unless there's an override
            // in the remote config.
            config.captureEnabled = true;
            _j.label = 1;
          case 1:
            _j.trys.push([1, 5,, 6]);
            if (!this.remoteConfigFetch) {
              return [2 /*return*/, config];
            }
            return [4 /*yield*/, this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_sampling_config', sessionId)];
          case 2:
            samplingConfig_1 = _j.sent();
            return [4 /*yield*/, this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_privacy_config', sessionId)];
          case 3:
            privacyConfig = _j.sent();
            // This is intentionally forced to only be set through the remote config.
            _d = config;
            return [4 /*yield*/, this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_interaction_config', sessionId)];
          case 4:
            // This is intentionally forced to only be set through the remote config.
            _d.interactionConfig = _j.sent();
            if (samplingConfig_1 || privacyConfig) {
              remoteConfig = {};
              if (samplingConfig_1) {
                remoteConfig.sr_sampling_config = samplingConfig_1;
              }
              if (privacyConfig) {
                remoteConfig.sr_privacy_config = privacyConfig;
              }
            }
            return [3 /*break*/, 6];
          case 5:
            err_1 = _j.sent();
            knownError = err_1;
            this.localConfig.loggerProvider.warn(knownError.message);
            config.captureEnabled = true;
            return [3 /*break*/, 6];
          case 6:
            if (!remoteConfig) {
              return [2 /*return*/, config];
            }
            samplingConfig = remoteConfig.sr_sampling_config, remotePrivacyConfig = remoteConfig.sr_privacy_config;
            if (samplingConfig && Object.keys(samplingConfig).length > 0) {
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'capture_enabled')) {
                config.captureEnabled = samplingConfig.capture_enabled;
              } else {
                config.captureEnabled = false;
              }
              if (samplingConfig.sample_rate) {
                config.sampleRate = samplingConfig.sample_rate;
              }
            } else {
              // If config API response was valid (ie 200), but no config returned, assume that
              // customer has not yet set up config, and use sample rate from SDK options,
              // allowing for immediate replay capture
              config.captureEnabled = true;
              this.localConfig.loggerProvider.debug('Remote config successfully fetched, but no values set for project, Session Replay capture enabled.');
            }
            // Remote config join acts somewhat like a left join between the remote and the local
            // config. That is, remote config has precedence over local values as with sampling.
            // However, non conflicting values will be added to the lists.
            // Here's an example to illustrate:
            //
            // Remote config:   {'.selector1': 'MASK',   '.selector2': 'UNMASK'}
            // Local config:    {'.selector1': 'UNMASK',                         '.selector3': 'MASK'}
            //
            // Resolved config: {'.selector1': 'MASK',   '.selector2': 'UNMASK', '.selector3': 'MASK'}
            // config.privacyConfig = {
            //   ...(config.privacyConfig ?? {}),
            //   ...remotePrivacyConfig,
            // };
            if (remotePrivacyConfig) {
              localPrivacyConfig = (_a = config.privacyConfig) !== null && _a !== void 0 ? _a : {};
              joinedPrivacyConfig = {
                defaultMaskLevel: (_c = (_b = remotePrivacyConfig.defaultMaskLevel) !== null && _b !== void 0 ? _b : localPrivacyConfig.defaultMaskLevel) !== null && _c !== void 0 ? _c : 'medium',
                blockSelector: [],
                maskSelector: [],
                unmaskSelector: []
              };
              privacyConfigSelectorMap = function (privacyConfig) {
                var e_2, _a, e_3, _b, e_4, _c;
                var _d, _e, _f;
                var selectorMap = {};
                if (typeof privacyConfig.blockSelector === 'string') {
                  privacyConfig.blockSelector = [privacyConfig.blockSelector];
                }
                try {
                  for (var _g = __values((_d = privacyConfig.blockSelector) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var selector = _h.value;
                    selectorMap[selector] = 'block';
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                try {
                  for (var _j = __values((_e = privacyConfig.maskSelector) !== null && _e !== void 0 ? _e : []), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var selector = _k.value;
                    selectorMap[selector] = 'mask';
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }
                try {
                  for (var _l = __values((_f = privacyConfig.unmaskSelector) !== null && _f !== void 0 ? _f : []), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var selector = _m.value;
                    selectorMap[selector] = 'unmask';
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }
                return selectorMap;
              };
              selectorMap = _assign$(_assign$({}, privacyConfigSelectorMap(localPrivacyConfig)), privacyConfigSelectorMap(remotePrivacyConfig));
              try {
                for (_e = __values(Object.entries(selectorMap)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  _g = __read(_f.value, 2), selector = _g[0], selectorType = _g[1];
                  if (selectorType === 'mask') {
                    joinedPrivacyConfig.maskSelector.push(selector);
                  } else if (selectorType === 'block') {
                    joinedPrivacyConfig.blockSelector.push(selector);
                  } else if (selectorType === 'unmask') {
                    joinedPrivacyConfig.unmaskSelector.push(selector);
                  }
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
              config.privacyConfig = joinedPrivacyConfig;
            }
            return [2 /*return*/, config];
        }
      });
    });
  };
  return SessionReplayJoinedConfigGenerator;
}();
var createSessionReplayJoinedConfigGenerator = function createSessionReplayJoinedConfigGenerator(apiKey, options) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var joinedConfigGenerator;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          joinedConfigGenerator = new SessionReplayJoinedConfigGenerator(apiKey, options);
          return [4 /*yield*/, joinedConfigGenerator.initialize()];
        case 1:
          _a.sent();
          return [2 /*return*/, joinedConfigGenerator];
      }
    });
  });
};
var getSuccessMessage = function getSuccessMessage(sessionId) {
  return "Session replay event batch tracked successfully for session id ".concat(sessionId);
};
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, event batch rejected';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Session replay event batch rejected due to exceeded retry count';
var STORAGE_FAILURE = 'Failed to store session replay events in IndexedDB';
var MISSING_DEVICE_ID_MESSAGE = 'Session replay event batch not sent due to missing device ID';
var MISSING_API_KEY_MESSAGE = 'Session replay event batch not sent due to missing api key';
var RecordingStatus;
(function (RecordingStatus) {
  RecordingStatus["RECORDING"] = "recording";
  RecordingStatus["SENT"] = "sent";
})(RecordingStatus || (RecordingStatus = {}));
var currentSequenceKey = 'sessionCurrentSequence';
var sequencesToSendKey = 'sequencesToSend';
var keyValDatabaseExists = function keyValDatabaseExists() {
  var globalScope = getGlobalScope();
  return new Promise(function (resolve, reject) {
    if (!globalScope) {
      return reject(new Error('Global scope not found'));
    }
    if (!globalScope.indexedDB) {
      return reject(new Error('Session Replay: cannot find indexedDB'));
    }
    try {
      var request_1 = globalScope.indexedDB.open('keyval-store');
      request_1.onupgradeneeded = function () {
        if (request_1.result.version === 1) {
          request_1.result.close();
          request_1.transaction && request_1.transaction.abort();
          globalScope.indexedDB.deleteDatabase('keyval-store');
          resolve();
        }
      };
      request_1.onsuccess = function () {
        resolve(request_1.result);
      };
    } catch (e) {
      reject(e);
    }
  });
};
var batchPromiseAll = function batchPromiseAll(promiseBatch) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var chunkSize, batch;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(promiseBatch.length > 0)) return [3 /*break*/, 2];
          chunkSize = 10;
          batch = promiseBatch.splice(0, chunkSize);
          return [4 /*yield*/, Promise.all(batch)];
        case 1:
          _a.sent();
          return [3 /*break*/, 0];
        case 2:
          return [2 /*return*/];
      }
    });
  });
};
var defineObjectStores = function defineObjectStores(db) {
  var sequencesStore;
  var currentSequenceStore;
  if (!db.objectStoreNames.contains(currentSequenceKey)) {
    currentSequenceStore = db.createObjectStore(currentSequenceKey, {
      keyPath: 'sessionId'
    });
  }
  if (!db.objectStoreNames.contains(sequencesToSendKey)) {
    sequencesStore = db.createObjectStore(sequencesToSendKey, {
      keyPath: 'sequenceId',
      autoIncrement: true
    });
    sequencesStore.createIndex('sessionId', 'sessionId');
  }
  return {
    sequencesStore: sequencesStore,
    currentSequenceStore: currentSequenceStore
  };
};
var createStore = function createStore(dbName) {
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, openDB(dbName, 1, {
            upgrade: defineObjectStores
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var SessionReplayEventsIDBStore = /** @class */function () {
  function SessionReplayEventsIDBStore(_a) {
    var loggerProvider = _a.loggerProvider,
      apiKey = _a.apiKey,
      minInterval = _a.minInterval,
      maxInterval = _a.maxInterval;
    var _this = this;
    this.storageKey = '';
    this.maxPersistedEventsSize = MAX_EVENT_LIST_SIZE_IN_BYTES;
    this.timeAtLastSplit = null;
    /**
     * Determines whether to send the events list to the backend and start a new
     * empty events list, based on the size of the list as well as the last time sent
     * @param nextEventString
     * @returns boolean
     */
    this.shouldSplitEventsList = function (events, nextEventString) {
      var sizeOfNextEvent = new Blob([nextEventString]).size;
      var sizeOfEventsList = new Blob(events).size;
      if (sizeOfEventsList + sizeOfNextEvent >= _this.maxPersistedEventsSize) {
        return true;
      }
      if (_this.timeAtLastSplit !== null && _this.interval && Date.now() - _this.timeAtLastSplit > _this.interval && events.length) {
        _this.interval = Math.min(_this.maxInterval, _this.interval + _this.minInterval);
        _this.timeAtLastSplit = Date.now();
        return true;
      }
      return false;
    };
    this.getSequencesToSend = function () {
      return __awaiter$1(_this, void 0, void 0, function () {
        var sequencesToSend, e_1;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 2,, 3]);
              return [4 /*yield*/, (_a = this.db) === null || _a === void 0 ? void 0 : _a.getAll(sequencesToSendKey)];
            case 1:
              sequencesToSend = _b.sent();
              return [2 /*return*/, sequencesToSend];
            case 2:
              e_1 = _b.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_1));
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.storeCurrentSequence = function (sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var currentSequenceData, sequenceId, e_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 4,, 5]);
              if (!this.db) {
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, this.db.get(currentSequenceKey, sessionId)];
            case 1:
              currentSequenceData = _a.sent();
              if (!currentSequenceData) {
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, this.db.put(sequencesToSendKey, {
                sessionId: sessionId,
                events: currentSequenceData.events
              })];
            case 2:
              sequenceId = _a.sent();
              return [4 /*yield*/, this.db.put(currentSequenceKey, {
                sessionId: sessionId,
                events: []
              })];
            case 3:
              _a.sent();
              return [2 /*return*/, _assign$(_assign$({}, currentSequenceData), {
                sessionId: sessionId,
                sequenceId: sequenceId
              })];
            case 4:
              e_2 = _a.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_2));
              return [3 /*break*/, 5];
            case 5:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.addEventToCurrentSequence = function (sessionId, event) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var tx, sequenceEvents, eventsToSend, updatedEvents, sequenceId, e_3;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (this.interval === 0) {
                this.interval = this.minInterval;
              }
              _b.label = 1;
            case 1:
              _b.trys.push([1, 11,, 12]);
              tx = (_a = this.db) === null || _a === void 0 ? void 0 : _a.transaction(currentSequenceKey, 'readwrite');
              if (!tx) {
                return [2 /*return*/];
              }
              return [4 /*yield*/, tx.store.get(sessionId)];
            case 2:
              sequenceEvents = _b.sent();
              if (!!sequenceEvents) return [3 /*break*/, 4];
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: [event]
              })];
            case 3:
              _b.sent();
              return [2 /*return*/];
            case 4:
              eventsToSend = void 0;
              if (!this.shouldSplitEventsList(sequenceEvents.events, event)) return [3 /*break*/, 6];
              eventsToSend = sequenceEvents.events;
              // set store to empty array
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: [event]
              })];
            case 5:
              // set store to empty array
              _b.sent();
              return [3 /*break*/, 8];
            case 6:
              updatedEvents = sequenceEvents.events.concat(event);
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: updatedEvents
              })];
            case 7:
              _b.sent();
              _b.label = 8;
            case 8:
              return [4 /*yield*/, tx.done];
            case 9:
              _b.sent();
              if (!eventsToSend) {
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, this.storeSendingEvents(sessionId, eventsToSend)];
            case 10:
              sequenceId = _b.sent();
              if (!sequenceId) {
                return [2 /*return*/, undefined];
              }
              return [2 /*return*/, {
                events: eventsToSend,
                sessionId: sessionId,
                sequenceId: sequenceId
              }];
            case 11:
              e_3 = _b.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_3));
              return [3 /*break*/, 12];
            case 12:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.storeSendingEvents = function (sessionId, events) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var sequenceId, e_4;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 2,, 3]);
              return [4 /*yield*/, (_a = this.db) === null || _a === void 0 ? void 0 : _a.put(sequencesToSendKey, {
                sessionId: sessionId,
                events: events
              })];
            case 1:
              sequenceId = _b.sent();
              return [2 /*return*/, sequenceId];
            case 2:
              e_4 = _b.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_4));
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.cleanUpSessionEventsStore = function (sequenceId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var e_5;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 2,, 3]);
              return [4 /*yield*/, (_a = this.db) === null || _a === void 0 ? void 0 : _a.delete(sequencesToSendKey, sequenceId)];
            case 1:
              _b.sent();
              return [3 /*break*/, 3];
            case 2:
              e_5 = _b.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_5));
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/];
          }
        });
      });
    };
    this.transitionFromKeyValStore = function (sessionId) {
      return __awaiter$1(_this, void 0, void 0, function () {
        var keyValDb, transitionCurrentSessionSequences_1, storageKey, getAllRequest_1, transitionPromise, globalScope, e_6, e_7;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 6,, 7]);
              return [4 /*yield*/, keyValDatabaseExists()];
            case 1:
              keyValDb = _a.sent();
              if (!keyValDb) {
                return [2 /*return*/];
              }
              transitionCurrentSessionSequences_1 = function (numericSessionId, sessionStore) {
                return __awaiter$1(_this, void 0, void 0, function () {
                  var currentSessionSequences, promisesToBatch;
                  var _this = this;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        currentSessionSequences = sessionStore.sessionSequences;
                        promisesToBatch = [];
                        Object.keys(currentSessionSequences).forEach(function (sequenceId) {
                          var numericSequenceId = parseInt(sequenceId, 10);
                          var sequence = currentSessionSequences[numericSequenceId];
                          if (numericSequenceId === sessionStore.currentSequenceId) {
                            var eventAddPromises = sequence.events.map(function (event) {
                              return __awaiter$1(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                  return [2 /*return*/, this.addEventToCurrentSequence(numericSessionId, event)];
                                });
                              });
                            });
                            promisesToBatch.concat(eventAddPromises);
                          } else if (sequence.status !== RecordingStatus.SENT) {
                            promisesToBatch.push(_this.storeSendingEvents(numericSessionId, sequence.events));
                          }
                        });
                        return [4 /*yield*/, batchPromiseAll(promisesToBatch)];
                      case 1:
                        _a.sent();
                        return [2 /*return*/];
                    }
                  });
                });
              };
              storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.apiKey.substring(0, 10));
              _a.label = 2;
            case 2:
              _a.trys.push([2, 4,, 5]);
              getAllRequest_1 = keyValDb.transaction('keyval').objectStore('keyval').getAll(storageKey);
              transitionPromise = new Promise(function (resolve) {
                getAllRequest_1.onsuccess = function (e) {
                  return __awaiter$1(_this, void 0, void 0, function () {
                    var storedReplaySessionContextList, storedReplaySessionContexts, promisesToBatch_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                      switch (_a.label) {
                        case 0:
                          storedReplaySessionContextList = e && e.target.result;
                          storedReplaySessionContexts = storedReplaySessionContextList && storedReplaySessionContextList[0];
                          if (!storedReplaySessionContexts) return [3 /*break*/, 2];
                          promisesToBatch_1 = [];
                          Object.keys(storedReplaySessionContexts).forEach(function (storedSessionId) {
                            var numericSessionId = parseInt(storedSessionId, 10);
                            var oldSessionStore = storedReplaySessionContexts[numericSessionId];
                            if (sessionId === numericSessionId) {
                              promisesToBatch_1.push(transitionCurrentSessionSequences_1(numericSessionId, oldSessionStore));
                            } else {
                              var oldSessionSequences_1 = oldSessionStore.sessionSequences;
                              Object.keys(oldSessionSequences_1).forEach(function (sequenceId) {
                                var numericSequenceId = parseInt(sequenceId, 10);
                                if (oldSessionSequences_1[numericSequenceId].status !== RecordingStatus.SENT) {
                                  promisesToBatch_1.push(_this.storeSendingEvents(numericSessionId, oldSessionSequences_1[numericSequenceId].events));
                                }
                              });
                            }
                          });
                          return [4 /*yield*/, batchPromiseAll(promisesToBatch_1)];
                        case 1:
                          _a.sent();
                          _a.label = 2;
                        case 2:
                          resolve();
                          return [2 /*return*/];
                      }
                    });
                  });
                };
              });
              return [4 /*yield*/, transitionPromise];
            case 3:
              _a.sent();
              globalScope = getGlobalScope();
              if (globalScope) {
                globalScope.indexedDB.deleteDatabase('keyval-store');
              }
              return [3 /*break*/, 5];
            case 4:
              e_6 = _a.sent();
              this.loggerProvider.warn("Failed to transition session replay events from keyval to new store: ".concat(e_6));
              return [3 /*break*/, 5];
            case 5:
              return [3 /*break*/, 7];
            case 6:
              e_7 = _a.sent();
              this.loggerProvider.warn("Failed to access keyval store: ".concat(e_7, ". For more information, visit: https://www.docs.developers.amplitude.com/session-replay/sdks/standalone/#indexeddb-best-practices"));
              return [3 /*break*/, 7];
            case 7:
              return [2 /*return*/];
          }
        });
      });
    };
    this.loggerProvider = loggerProvider;
    this.apiKey = apiKey;
    this.maxInterval = maxInterval !== null && maxInterval !== void 0 ? maxInterval : MAX_INTERVAL;
    this.minInterval = minInterval !== null && minInterval !== void 0 ? minInterval : MIN_INTERVAL;
    this.interval = 0;
  }
  SessionReplayEventsIDBStore.prototype.initialize = function (type, sessionId) {
    return __awaiter$1(this, void 0, void 0, function () {
      var dbSuffix, dbName, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            dbSuffix = type === 'replay' ? '' : "_".concat(type);
            dbName = "".concat(this.apiKey.substring(0, 10), "_amp_session_replay_events").concat(dbSuffix);
            _a = this;
            return [4 /*yield*/, createStore(dbName)];
          case 1:
            _a.db = _b.sent();
            this.timeAtLastSplit = Date.now(); // Initialize this so we have a point of comparison when events are recorded
            return [4 /*yield*/, this.transitionFromKeyValStore(sessionId)];
          case 2:
            _b.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  return SessionReplayEventsIDBStore;
}();
var createEventsIDBStore = function createEventsIDBStore(_a) {
  var loggerProvider = _a.loggerProvider,
    apiKey = _a.apiKey,
    sessionId = _a.sessionId,
    type = _a.type,
    minInterval = _a.minInterval,
    maxInterval = _a.maxInterval;
  return __awaiter$1(void 0, void 0, void 0, function () {
    var eventsIDBStore;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          eventsIDBStore = new SessionReplayEventsIDBStore({
            loggerProvider: loggerProvider,
            apiKey: apiKey,
            minInterval: minInterval,
            maxInterval: maxInterval
          });
          return [4 /*yield*/, eventsIDBStore.initialize(type, sessionId)];
        case 1:
          _b.sent();
          return [2 /*return*/, eventsIDBStore];
      }
    });
  });
};
var DEFAULT_MASK_LEVEL = 'medium';
var NodeType;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
function toLowerCase(str) {
  return str.toLowerCase();
}
function getInputType(element) {
  const type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ? toLowerCase(type) : null;
}

/**
 * Light: Subset of inputs
 * Medium: All inputs
 * Conservative: All inputs and all texts
 */
var isMaskedForLevel = function isMaskedForLevel(elementType, level, element) {
  switch (level) {
    case 'light':
      {
        if (elementType !== 'input') {
          return true;
        }
        var inputType = element ? getInputType(element) : '';
        /* istanbul ignore if */ // TODO(lew): For some reason it's impossible to test this.
        if (!inputType) {
          return false;
        }
        if (['password', 'hidden', 'email', 'tel'].includes(inputType)) {
          return true;
        }
        if (element.autocomplete.startsWith('cc-')) {
          return true;
        }
        return false;
      }
    case 'medium':
    case 'conservative':
      return true;
    default:
      return isMaskedForLevel(elementType, DEFAULT_MASK_LEVEL, element);
  }
};
/**
 * Checks if the given element set to be masked by rrweb
 *
 * Priority is:
 *  1. [In code] Element/class based masking/unmasking <> [Config based] Selector based masking/unmasking
 *  2. Use app defaults
 */
var isMasked = function isMasked(elementType, config, element) {
  var _a, _b, _c;
  if (config === void 0) {
    config = {
      defaultMaskLevel: DEFAULT_MASK_LEVEL
    };
  }
  if (element) {
    // Element or parent is explicitly instrumented in code to mask
    if (element.closest('.' + MASK_TEXT_CLASS)) {
      return true;
    }
    // Config has override for mask
    var shouldMask = ((_a = config.maskSelector) !== null && _a !== void 0 ? _a : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldMask) {
      return true;
    }
    // Code or config has override to unmask
    if (element.closest('.' + UNMASK_TEXT_CLASS)) {
      return false;
    }
    // Here we are probably sent an element, but we want to match if they have a
    // parent with an unmask selector.
    var shouldUnmask = ((_b = config.unmaskSelector) !== null && _b !== void 0 ? _b : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldUnmask) {
      return false;
    }
  }
  return isMaskedForLevel(elementType, (_c = config.defaultMaskLevel) !== null && _c !== void 0 ? _c : DEFAULT_MASK_LEVEL, element);
};
var maskFn = function maskFn(elementType, config) {
  return function (text, element) {
    return isMasked(elementType, config, element) ? text.replace(/[^\s]/g, '*') : text;
  };
};
var generateHashCode = function generateHashCode(str) {
  var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
    var chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};
var isSessionInSample = function isSessionInSample(sessionId, sampleRate) {
  var hashNumber = generateHashCode(sessionId.toString());
  var absHash = Math.abs(hashNumber);
  var absHashMultiply = absHash * 31;
  var mod = absHashMultiply % 1000000;
  return mod / 1000000 < sampleRate;
};
var getCurrentUrl = function getCurrentUrl() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) ? globalScope.location.href : '';
};
var generateSessionReplayId = function generateSessionReplayId(sessionId, deviceId) {
  return "".concat(deviceId, "/").concat(sessionId);
};
var getServerUrl = function getServerUrl(serverZone) {
  if (serverZone === ServerZone.STAGING) {
    return SESSION_REPLAY_STAGING_URL;
  }
  if (serverZone === ServerZone.EU) {
    return SESSION_REPLAY_EU_URL;
  }
  return SESSION_REPLAY_SERVER_URL;
};
var VERSION = '0.2.5';
var SessionReplayTrackDestination = /** @class */function () {
  function SessionReplayTrackDestination(_a) {
    var loggerProvider = _a.loggerProvider,
      payloadBatcher = _a.payloadBatcher;
    this.storageKey = '';
    this.retryTimeout = 1000;
    this.scheduled = null;
    this.queue = [];
    this.loggerProvider = loggerProvider;
    this.payloadBatcher = payloadBatcher ? payloadBatcher : function (payload) {
      return payload;
    };
  }
  SessionReplayTrackDestination.prototype.sendEventsList = function (destinationData) {
    this.addToQueue(_assign$(_assign$({}, destinationData), {
      attempts: 0,
      timeout: 0
    }));
  };
  SessionReplayTrackDestination.prototype.addToQueue = function () {
    var _this = this;
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      list[_i] = arguments[_i];
    }
    var tryable = list.filter(function (context) {
      if (context.attempts < (context.flushMaxRetries || 0)) {
        context.attempts += 1;
        return true;
      }
      _this.completeRequest({
        context: context,
        err: "".concat(MAX_RETRIES_EXCEEDED_MESSAGE, ", batch sequence id, ").concat(context.sequenceId)
      });
      return false;
    });
    tryable.forEach(function (context) {
      _this.queue = _this.queue.concat(context);
      if (context.timeout === 0) {
        _this.schedule(0);
        return;
      }
      setTimeout(function () {
        context.timeout = 0;
        _this.schedule(0);
      }, context.timeout);
    });
  };
  SessionReplayTrackDestination.prototype.schedule = function (timeout) {
    var _this = this;
    if (this.scheduled) return;
    this.scheduled = setTimeout(function () {
      void _this.flush(true).then(function () {
        if (_this.queue.length > 0) {
          _this.schedule(timeout);
        }
      });
    }, timeout);
  };
  SessionReplayTrackDestination.prototype.flush = function (useRetry) {
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter$1(this, void 0, void 0, function () {
      var list, later;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            list = [];
            later = [];
            this.queue.forEach(function (context) {
              return context.timeout === 0 ? list.push(context) : later.push(context);
            });
            this.queue = later;
            if (this.scheduled) {
              clearTimeout(this.scheduled);
              this.scheduled = null;
            }
            return [4 /*yield*/, Promise.all(list.map(function (context) {
              return _this.send(context, useRetry);
            }))];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.send = function (context, useRetry) {
    if (useRetry === void 0) {
      useRetry = true;
    }
    return __awaiter$1(this, void 0, void 0, function () {
      var apiKey, deviceId, url, version, sampleRate, urlParams, payload, options, server_url, res, responseBody, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            apiKey = context.apiKey;
            if (!apiKey) {
              return [2 /*return*/, this.completeRequest({
                context: context,
                err: MISSING_API_KEY_MESSAGE
              })];
            }
            deviceId = context.deviceId;
            if (!deviceId) {
              return [2 /*return*/, this.completeRequest({
                context: context,
                err: MISSING_DEVICE_ID_MESSAGE
              })];
            }
            url = getCurrentUrl();
            version = VERSION;
            sampleRate = context.sampleRate;
            urlParams = new URLSearchParams({
              device_id: deviceId,
              session_id: "".concat(context.sessionId),
              seq_number: "".concat(context.sequenceId),
              type: "".concat(context.type)
            });
            payload = this.payloadBatcher({
              version: 1,
              events: context.events
            });
            if (payload.events.length === 0) {
              this.completeRequest({
                context: context
              });
              return [2 /*return*/];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            options = {
              headers: {
                'Content-Type': 'application/json',
                Accept: '*/*',
                Authorization: "Bearer ".concat(apiKey),
                'X-Client-Version': version,
                'X-Client-Url': url,
                'X-Client-Sample-Rate': "".concat(sampleRate)
              },
              body: JSON.stringify(payload),
              method: 'POST'
            };
            server_url = "".concat(getServerUrl(context.serverZone), "?").concat(urlParams.toString());
            return [4 /*yield*/, fetch(server_url, options)];
          case 2:
            res = _a.sent();
            if (res === null) {
              this.completeRequest({
                context: context,
                err: UNEXPECTED_ERROR_MESSAGE
              });
              return [2 /*return*/];
            }
            if (!useRetry) {
              responseBody = '';
              try {
                responseBody = JSON.stringify(res.body, null, 2);
              } catch (_b) {
                // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
              }
              this.completeRequest({
                context: context,
                success: "".concat(res.status, ": ").concat(responseBody)
              });
            } else {
              this.handleReponse(res.status, context);
            }
            return [3 /*break*/, 4];
          case 3:
            e_1 = _a.sent();
            this.completeRequest({
              context: context,
              err: e_1
            });
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.handleReponse = function (status, context) {
    var parsedStatus = new BaseTransport().buildStatus(status);
    switch (parsedStatus) {
      case Status.Success:
        this.handleSuccessResponse(context);
        break;
      case Status.Failed:
        this.handleOtherResponse(context);
        break;
      default:
        this.completeRequest({
          context: context,
          err: UNEXPECTED_NETWORK_ERROR_MESSAGE
        });
    }
  };
  SessionReplayTrackDestination.prototype.handleSuccessResponse = function (context) {
    this.completeRequest({
      context: context,
      success: getSuccessMessage(context.sessionId)
    });
  };
  SessionReplayTrackDestination.prototype.handleOtherResponse = function (context) {
    this.addToQueue(_assign$(_assign$({}, context), {
      timeout: context.attempts * this.retryTimeout
    }));
  };
  SessionReplayTrackDestination.prototype.completeRequest = function (_a) {
    var context = _a.context,
      err = _a.err,
      success = _a.success;
    void context.onComplete(context.sequenceId);
    if (err) {
      this.loggerProvider.warn(err);
    } else if (success) {
      this.loggerProvider.log(success);
    }
  };
  return SessionReplayTrackDestination;
}();
var createEventsManager = function createEventsManager(_a) {
  var config = _a.config,
    sessionId = _a.sessionId,
    minInterval = _a.minInterval,
    maxInterval = _a.maxInterval,
    type = _a.type,
    payloadBatcher = _a.payloadBatcher;
  return __awaiter$1(void 0, void 0, void 0, function () {
    function flush(useRetry) {
      if (useRetry === void 0) {
        useRetry = false;
      }
      return __awaiter$1(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2 /*return*/, trackDestination.flush(useRetry)];
        });
      });
    }
    var trackDestination, eventsIDBStore, sendEventsList, sendCurrentSequenceEvents, sendStoredEvents, addEvent;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          trackDestination = new SessionReplayTrackDestination({
            loggerProvider: config.loggerProvider,
            payloadBatcher: payloadBatcher
          });
          return [4 /*yield*/, createEventsIDBStore({
            loggerProvider: config.loggerProvider,
            apiKey: config.apiKey,
            sessionId: sessionId,
            minInterval: minInterval,
            maxInterval: maxInterval,
            type: type
          })];
        case 1:
          eventsIDBStore = _b.sent();
          sendEventsList = function (_a) {
            var events = _a.events,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId,
              sequenceId = _a.sequenceId;
            trackDestination.sendEventsList({
              events: events,
              sequenceId: sequenceId,
              sessionId: sessionId,
              flushMaxRetries: config.flushMaxRetries,
              apiKey: config.apiKey,
              deviceId: deviceId,
              sampleRate: config.sampleRate,
              serverZone: config.serverZone,
              type: type,
              onComplete: eventsIDBStore.cleanUpSessionEventsStore.bind(eventsIDBStore)
            });
          };
          sendCurrentSequenceEvents = function (_a) {
            var sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            eventsIDBStore.storeCurrentSequence(sessionId).then(function (currentSequence) {
              if (currentSequence) {
                sendEventsList({
                  sequenceId: currentSequence.sequenceId,
                  events: currentSequence.events,
                  sessionId: currentSequence.sessionId,
                  deviceId: deviceId
                });
              }
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to get current sequence of session replay events for session:', e);
            });
          };
          sendStoredEvents = function (_a) {
            var deviceId = _a.deviceId;
            return __awaiter$1(void 0, void 0, void 0, function () {
              var sequencesToSend;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [4 /*yield*/, eventsIDBStore.getSequencesToSend()];
                  case 1:
                    sequencesToSend = _b.sent();
                    sequencesToSend && sequencesToSend.forEach(function (sequence) {
                      sendEventsList({
                        sequenceId: sequence.sequenceId,
                        events: sequence.events,
                        sessionId: sequence.sessionId,
                        deviceId: deviceId
                      });
                    });
                    return [2 /*return*/];
                }
              });
            });
          };
          addEvent = function (_a) {
            var event = _a.event,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            eventsIDBStore.addEventToCurrentSequence(sessionId, event.data).then(function (sequenceToSend) {
              return sequenceToSend && sendEventsList({
                sequenceId: sequenceToSend.sequenceId,
                events: sequenceToSend.events,
                sessionId: sequenceToSend.sessionId,
                deviceId: deviceId
              });
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to add event to session replay capture:', e);
            });
          };
          return [2 /*return*/, {
            sendCurrentSequenceEvents: sendCurrentSequenceEvents,
            addEvent: addEvent,
            sendStoredEvents: sendStoredEvents,
            flush: flush
          }];
      }
    });
  });
};

/**
 * "Registers" events managers internally. When an event is added this class routes the event to the correct
 * manager. For all send or flush methods this will invoke the event for all registered managers.
 */
var MultiEventManager = /** @class */function () {
  function MultiEventManager() {
    var managers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      managers[_i] = arguments[_i];
    }
    var managersMap = new Map();
    managers.forEach(function (t) {
      managersMap.set(t.name, t.manager);
    });
    this.managers = managersMap;
  }
  MultiEventManager.prototype.sendStoredEvents = function (opts) {
    return __awaiter$1(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.sendStoredEvents(opts));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  MultiEventManager.prototype.addEvent = function (_a) {
    var _b;
    var sessionId = _a.sessionId,
      event = _a.event,
      deviceId = _a.deviceId;
    (_b = this.managers.get(event.type)) === null || _b === void 0 ? void 0 : _b.addEvent({
      sessionId: sessionId,
      event: event,
      deviceId: deviceId
    });
  };
  MultiEventManager.prototype.sendCurrentSequenceEvents = function (_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.managers.forEach(function (manager) {
      manager.sendCurrentSequenceEvents({
        sessionId: sessionId,
        deviceId: deviceId
      });
    });
  };
  MultiEventManager.prototype.flush = function (useRetry) {
    return __awaiter$1(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.flush(useRetry));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  return MultiEventManager;
}();
var MouseInteractions = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});

/* istanbul ignore file */
var config;
var rootDocument;
var start;
function finder(input, options) {
  start = new Date();
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }
  if ('html' === input.tagName.toLowerCase()) {
    return 'html';
  }
  var defaults = {
    root: document.body,
    idName: function (_name) {
      return true;
    },
    className: function (_name) {
      return true;
    },
    tagName: function (_name) {
      return true;
    },
    attr: function (_name, _value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1000,
    maxNumberOfTries: 10000,
    timeoutMs: undefined
  };
  config = _assign$(_assign$({}, defaults), options);
  rootDocument = findRootDocument(config.root, defaults);
  var path = bottomUpSearch(input, 'all', function () {
    return bottomUpSearch(input, 'two', function () {
      return bottomUpSearch(input, 'one', function () {
        return bottomUpSearch(input, 'none');
      });
    });
  });
  if (path) {
    var optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}
function findRootDocument(rootNode, defaults) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;
  var _loop_1 = function _loop_1() {
    var e_1, _a;
    var elapsedTime = new Date().getTime() - start.getTime();
    if (config.timeoutMs !== undefined && elapsedTime > config.timeoutMs) {
      throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
    }
    var level = maybe(id(current)) || maybe.apply(void 0, __spreadArray([], __read(attr(current)), false)) || maybe.apply(void 0, __spreadArray([], __read(classNames(current)), false)) || maybe(tagName(current)) || [any()];
    var nth = index(current);
    if (limit == 'all') {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'two') {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'one') {
      var _b = __read(level = level.slice(0, 1), 1),
        node = _b[0];
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == 'none') {
      level = [any()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    try {
      for (var level_1 = (e_1 = void 0, __values(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
        var node = level_1_1.value;
        node.level = i;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        return "break";
      }
    }
    current = current.parentElement;
    i++;
  };
  while (current) {
    var state_1 = _loop_1();
    if (state_1 === "break") break;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  var e_2, _a;
  var paths = sort(combinations(stack));
  if (paths.length > config.threshold) {
    return fallback ? fallback() : null;
  }
  try {
    for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var candidate = paths_1_1.value;
      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
}
function selector(path) {
  var node = path[0];
  var query = node.name;
  for (var i = 1; i < path.length; i++) {
    var level = path[i].level || 0;
    if (node.level === level - 1) {
      query = "".concat(path[i].name, " > ").concat(query);
    } else {
      query = "".concat(path[i].name, " ").concat(query);
    }
    node = path[i];
  }
  return query;
}
function penalty(path) {
  return path.map(function (node) {
    return node.penalty;
  }).reduce(function (acc, i) {
    return acc + i;
  }, 0);
}
function unique(path) {
  var css = selector(path);
  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  var elementId = input.getAttribute('id');
  if (elementId && config.idName(elementId)) {
    return {
      name: '#' + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  var attrs = Array.from(input.attributes).filter(function (attr) {
    return config.attr(attr.name, attr.value);
  });
  return attrs.map(function (attr) {
    return {
      name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
      penalty: 0.5
    };
  });
}
function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function (name) {
    return {
      name: '.' + CSS.escape(name),
      penalty: 1
    };
  });
}
function tagName(input) {
  var name = input.tagName.toLowerCase();
  if (config.tagName(name)) {
    return {
      name: name,
      penalty: 2
    };
  }
  return null;
}
function any() {
  return {
    name: '*',
    penalty: 3
  };
}
function index(input) {
  var parent = input.parentNode;
  if (!parent) {
    return null;
  }
  var child = parent.firstChild;
  if (!child) {
    return null;
  }
  var i = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i;
}
function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== 'html' && !node.name.startsWith('#');
}
function maybe() {
  var level = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    level[_i] = arguments[_i];
  }
  var list = level.filter(notEmpty);
  if (list.length > 0) {
    return list;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== undefined;
}
function combinations(stack, path) {
  var _a, _b, node, e_3_1;
  var e_3, _c;
  if (path === void 0) {
    path = [];
  }
  return __generator(this, function (_d) {
    switch (_d.label) {
      case 0:
        if (!(stack.length > 0)) return [3 /*break*/, 9];
        _d.label = 1;
      case 1:
        _d.trys.push([1, 6, 7, 8]);
        _a = __values(stack[0]), _b = _a.next();
        _d.label = 2;
      case 2:
        if (!!_b.done) return [3 /*break*/, 5];
        node = _b.value;
        return [5 /*yield**/, __values(combinations(stack.slice(1, stack.length), path.concat(node)))];
      case 3:
        _d.sent();
        _d.label = 4;
      case 4:
        _b = _a.next();
        return [3 /*break*/, 2];
      case 5:
        return [3 /*break*/, 8];
      case 6:
        e_3_1 = _d.sent();
        e_3 = {
          error: e_3_1
        };
        return [3 /*break*/, 8];
      case 7:
        try {
          if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        } finally {
          if (e_3) throw e_3.error;
        }
        return [7 /*endfinally*/];
      case 8:
        return [3 /*break*/, 11];
      case 9:
        return [4 /*yield*/, path];
      case 10:
        _d.sent();
        _d.label = 11;
      case 11:
        return [2 /*return*/];
    }
  });
}
function sort(paths) {
  return __spreadArray([], __read(paths), false).sort(function (a, b) {
    return penalty(a) - penalty(b);
  });
}
function optimize(path, input, scope) {
  var i, newPath, newPathKey;
  if (scope === void 0) {
    scope = {
      counter: 0,
      visited: new Map()
    };
  }
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        if (!(path.length > 2 && path.length > config.optimizedMinLength)) return [3 /*break*/, 5];
        i = 1;
        _a.label = 1;
      case 1:
        if (!(i < path.length - 1)) return [3 /*break*/, 5];
        if (scope.counter > config.maxNumberOfTries) {
          return [2 /*return*/]; // Okay At least I tried!
        }
        scope.counter += 1;
        newPath = __spreadArray([], __read(path), false);
        newPath.splice(i, 1);
        newPathKey = selector(newPath);
        if (scope.visited.has(newPathKey)) {
          return [2 /*return*/];
        }
        if (!(unique(newPath) && same(newPath, input))) return [3 /*break*/, 4];
        return [4 /*yield*/, newPath];
      case 2:
        _a.sent();
        scope.visited.set(newPathKey, true);
        return [5 /*yield**/, __values(optimize(newPath, input, scope))];
      case 3:
        _a.sent();
        _a.label = 4;
      case 4:
        i++;
        return [3 /*break*/, 1];
      case 5:
        return [2 /*return*/];
    }
  });
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var HOUR_IN_MILLISECONDS = 3600000;
var clickBatcher = function clickBatcher(_a) {
  var version = _a.version,
    events = _a.events;
  var clickEvents = [];
  events.forEach(function (evt) {
    var record = JSON.parse(evt);
    if (record.type === 'click') {
      clickEvents.push(record);
    }
  });
  var reduced = clickEvents.reduce(function (prev, curr) {
    var x = curr.x,
      y = curr.y,
      selector = curr.selector,
      timestamp = curr.timestamp;
    // round down to nearest hour.
    var hour = timestamp - timestamp % HOUR_IN_MILLISECONDS;
    var k = "".concat(x, ":").concat(y, ":").concat(selector !== null && selector !== void 0 ? selector : '', ":").concat(hour);
    if (!prev[k]) {
      prev[k] = _assign$(_assign$({}, curr), {
        timestamp: hour,
        count: 1
      });
    } else {
      prev[k].count += 1;
    }
    return prev;
  }, {});
  return {
    version: version,
    events: Object.values(reduced)
  };
};
var clickHook = function clickHook(_a) {
  var eventsManager = _a.eventsManager,
    sessionId = _a.sessionId,
    deviceIdFn = _a.deviceIdFn;
  return function (e) {
    if (e.type !== MouseInteractions.Click) {
      return;
    }
    var globalScope = getGlobalScope();
    if (!globalScope) {
      return;
    }
    var location = globalScope.location,
      innerHeight = globalScope.innerHeight,
      innerWidth = globalScope.innerWidth;
    // it only makes sense to send events if a pageUrl exists
    if (!location) {
      return;
    }
    var x = e.x,
      y = e.y;
    var node = record.mirror.getNode(e.id);
    var selector;
    if (node) {
      selector = finder(node);
    }
    var _a = getWindowScroll(globalScope),
      scrollX = _a.left,
      scrollY = _a.top;
    var event = {
      x: x + scrollX,
      y: y + scrollY,
      selector: selector,
      viewportHeight: innerHeight,
      viewportWidth: innerWidth,
      pageUrl: location.href,
      timestamp: Date.now(),
      type: 'click'
    };
    var deviceId = deviceIdFn();
    if (deviceId) {
      eventsManager.addEvent({
        sessionId: sessionId,
        event: {
          type: 'interaction',
          data: JSON.stringify(event)
        },
        deviceId: deviceId
      });
    }
  };
};

/**
 * For very small payloads it's preferable to use the [Beacon API](https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API).
 * While it doesn't provide 100% guarantees on sends, it greatly helps with overall reliability and page load performance. As
 * the Beacon API has a potential to fail due to size constraints we want to fall back to XHR if need be. This is mostly to
 * be used with 'pagehide' or 'beforeunload' events.
 *
 * Note there are only 3 CORS safelisted Content-Types you can send:
 *
 * - application/x-www-form-urlencoded
 * - multipart/form-data
 * - text/plain
 *
 * If we do not send one of these, some browsers like Chrome may not send this at all. Also we incur the overhead of a preflight
 * request. In our case we will add no additional content-type header. If you are trying to ping a server that requires this
 * header, you may want to use the regular fetch API or a different mechanism.
 */
var BeaconTransport = /** @class */function () {
  function BeaconTransport(context, config) {
    var globalScope = getGlobalScope();
    if (globalScope && globalScope.navigator && typeof globalScope.navigator.sendBeacon === 'function') {
      this.sendBeacon = function (pageUrl, payload) {
        try {
          if (globalScope.navigator.sendBeacon(pageUrl, JSON.stringify(payload))) {
            return true;
          }
        } catch (e) {
          // not logging error, since it would be hard to view and just adds overhead.
        }
        return false;
      };
    } else {
      this.sendBeacon = function () {
        return false;
      };
    }
    this.sendXhr = function (pageUrl, payload) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', pageUrl, true);
      xhr.setRequestHeader('Accept', '*/*');
      xhr.send(JSON.stringify(payload));
      return true;
    };
    this.basePageUrl = getServerUrl(config.serverZone);
    this.context = context;
  }
  BeaconTransport.prototype.send = function (deviceId, payload) {
    var _a = this.context,
      sessionId = _a.sessionId,
      type = _a.type;
    var urlParams = new URLSearchParams({
      device_id: deviceId,
      session_id: String(sessionId),
      type: String(type)
    });
    var pageUrl = "".concat(this.basePageUrl, "?").concat(urlParams.toString());
    // ideally send using the beacon API, but there is a chance it may fail, possibly due to a payload
    // size limit. in this case, try best effort to send using xhr.
    this.sendBeacon(pageUrl, payload) || this.sendXhr(pageUrl, payload);
  };
  return BeaconTransport;
}();
var getWindowHeight = getWindowHeight$1,
  getWindowWidth = getWindowWidth$1;
/**
 * This is intended to watch and update max scroll activity when loaded for a particular page.
 * A new instance should be created if the page URL changes, since by default it does not reset
 * it's max scroll state. It is intended to send very few and very small events utilizing the
 * Beacon API.
 * @see {@link BeaconTransport} for more details on Beacon API usage.
 */
var ScrollWatcher = /** @class */function () {
  function ScrollWatcher(transport) {
    var _this = this;
    this.timestamp = Date.now();
    this.hook = function (e) {
      _this.update(e);
    };
    this.send = function (deviceIdFn) {
      return function (_) {
        var deviceId = deviceIdFn();
        var globalScope = getGlobalScope();
        if (globalScope && deviceId) {
          _this.transport.send(deviceId, {
            maxScrollX: _this._maxScrollX,
            maxScrollY: _this._maxScrollY,
            maxScrollWidth: _this._maxScrollWidth,
            maxScrollHeight: _this._maxScrollHeight,
            viewportHeight: getWindowHeight(),
            viewportWidth: getWindowWidth(),
            pageUrl: globalScope.location.href,
            timestamp: _this.timestamp,
            type: 'scroll'
          });
        }
      };
    };
    this._maxScrollX = 0;
    this._maxScrollY = 0;
    this._maxScrollWidth = getWindowWidth();
    this._maxScrollHeight = getWindowHeight();
    this.transport = transport;
  }
  ScrollWatcher.default = function (context, config) {
    return new ScrollWatcher(new BeaconTransport(context, config));
  };
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollX", {
    get: function () {
      return this._maxScrollX;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollY", {
    get: function () {
      return this._maxScrollY;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollWidth", {
    get: function () {
      return this._maxScrollWidth;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollHeight", {
    get: function () {
      return this._maxScrollHeight;
    },
    enumerable: false,
    configurable: true
  });
  ScrollWatcher.prototype.update = function (e) {
    var now = Date.now();
    if (e.x > this._maxScrollX) {
      var width = getWindowWidth();
      this._maxScrollX = e.x;
      var maxScrollWidth = e.x + width;
      if (maxScrollWidth > this._maxScrollWidth) {
        this._maxScrollWidth = maxScrollWidth;
      }
      this.timestamp = now;
    }
    if (e.y > this._maxScrollY) {
      var height = getWindowHeight();
      this._maxScrollY = e.y;
      var maxScrollHeight = e.y + height;
      if (maxScrollHeight > this._maxScrollHeight) {
        this._maxScrollHeight = maxScrollHeight;
      }
      this.timestamp = now;
    }
  };
  return ScrollWatcher;
}();
var SessionIdentifiers = /** @class */function () {
  function SessionIdentifiers(_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.deviceId = deviceId;
    this.sessionId = sessionId;
    if (sessionId && deviceId) {
      this.sessionReplayId = generateSessionReplayId(sessionId, deviceId);
    }
  }
  return SessionIdentifiers;
}();
var SessionReplay = /** @class */function () {
  function SessionReplay() {
    var _this = this;
    this.name = '@amplitude/session-replay-browser';
    this.recordCancelCallback = null;
    // Visible for testing
    this.pageLeaveFns = [];
    this.teardownEventListeners = function (teardown) {
      var globalScope = getGlobalScope();
      if (globalScope) {
        globalScope.removeEventListener('blur', _this.blurListener);
        globalScope.removeEventListener('focus', _this.focusListener);
        !teardown && globalScope.addEventListener('blur', _this.blurListener);
        !teardown && globalScope.addEventListener('focus', _this.focusListener);
        // prefer pagehide to unload events, this is the standard going forward. it is not
        // 100% reliable, but is bfcache-compatible.
        if (globalScope.self && 'onpagehide' in globalScope.self) {
          globalScope.removeEventListener('pagehide', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('pagehide', _this.pageLeaveListener);
        } else {
          // this has performance implications, but is the only way we can reliably send events
          // in browser that don't support pagehide.
          globalScope.removeEventListener('beforeunload', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('beforeunload', _this.pageLeaveListener);
        }
      }
    };
    this.blurListener = function () {
      _this.stopRecordingAndSendEvents();
    };
    this.focusListener = function () {
      _this.initialize();
    };
    /**
     * This is an instance member so that if init is called multiple times
     * it doesn't add another listener to the page leave event. This is to
     * prevent duplicate listener actions from firing.
     */
    this.pageLeaveListener = function (e) {
      _this.pageLeaveFns.forEach(function (fn) {
        fn(e);
      });
    };
    this.stopRecordingEvents = function () {
      try {
        _this.recordCancelCallback && _this.recordCancelCallback();
        _this.recordCancelCallback = null;
      } catch (error) {
        var typedError = error;
        _this.loggerProvider.warn("Error occurred while stopping recording: ".concat(typedError.toString()));
      }
    };
    this.loggerProvider = new Logger();
  }
  SessionReplay.prototype.init = function (apiKey, options) {
    return returnWrapper(this._init(apiKey, options));
  };
  SessionReplay.prototype.removeInvalidSelectors = function () {
    var _this = this;
    var _a;
    if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig)) {
      return;
    }
    // This allows us to not search the DOM.
    var fragment = document.createDocumentFragment();
    var dropInvalidSelectors = function dropInvalidSelectors(selectors) {
      if (selectors === void 0) {
        selectors = [];
      }
      if (typeof selectors === 'string') {
        selectors = [selectors];
      }
      selectors = selectors.filter(function (selector) {
        try {
          fragment.querySelector(selector);
        } catch (_a) {
          _this.loggerProvider.warn("[session-replay-browser] omitting selector \"".concat(selector, "\" because it is invalid"));
          return false;
        }
        return true;
      });
      if (selectors.length === 0) {
        return undefined;
      }
      return selectors;
    };
    this.config.privacyConfig.blockSelector = dropInvalidSelectors(this.config.privacyConfig.blockSelector);
    this.config.privacyConfig.maskSelector = dropInvalidSelectors(this.config.privacyConfig.maskSelector);
    this.config.privacyConfig.unmaskSelector = dropInvalidSelectors(this.config.privacyConfig.unmaskSelector);
  };
  SessionReplay.prototype._init = function (apiKey, options) {
    var _a, _b, _c;
    return __awaiter$1(this, void 0, void 0, function () {
      var _d, _e, scrollWatcher, managers, rrwebEventManager, interactionEventManager, globalScope;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            this.loggerProvider = options.loggerProvider || new Logger();
            Object.prototype.hasOwnProperty.call(options, 'logLevel') && this.loggerProvider.enable(options.logLevel);
            this.identifiers = new SessionIdentifiers({
              sessionId: options.sessionId,
              deviceId: options.deviceId
            });
            _d = this;
            return [4 /*yield*/, createSessionReplayJoinedConfigGenerator(apiKey, options)];
          case 1:
            _d.joinedConfigGenerator = _f.sent();
            _e = this;
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)];
          case 2:
            _e.config = _f.sent();
            this.loggerProvider.debug(JSON.stringify({
              name: 'session replay joined privacy config',
              privacyConfig: this.config.privacyConfig
            }, null, 2));
            if (options.sessionId && ((_a = this.config.interactionConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
              scrollWatcher = ScrollWatcher.default({
                sessionId: options.sessionId,
                type: 'interaction'
              }, this.config);
              this.pageLeaveFns = [scrollWatcher.send(this.getDeviceId.bind(this))];
              this.scrollHook = scrollWatcher.hook.bind(scrollWatcher);
            }
            this.removeInvalidSelectors();
            managers = [];
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              sessionId: this.identifiers.sessionId,
              type: 'replay'
            })];
          case 3:
            rrwebEventManager = _f.sent();
            managers.push({
              name: 'replay',
              manager: rrwebEventManager
            });
            if (!((_b = this.config.interactionConfig) === null || _b === void 0 ? void 0 : _b.enabled)) return [3 /*break*/, 5];
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              sessionId: this.identifiers.sessionId,
              type: 'interaction',
              minInterval: (_c = this.config.interactionConfig.trackEveryNms) !== null && _c !== void 0 ? _c : INTERACTION_MIN_INTERVAL,
              maxInterval: INTERACTION_MAX_INTERVAL,
              payloadBatcher: clickBatcher
            })];
          case 4:
            interactionEventManager = _f.sent();
            managers.push({
              name: 'interaction',
              manager: interactionEventManager
            });
            _f.label = 5;
          case 5:
            this.eventsManager = new (MultiEventManager.bind.apply(MultiEventManager, __spreadArray([void 0], __read(managers), false)))();
            this.loggerProvider.log('Installing @amplitude/session-replay-browser.');
            this.teardownEventListeners(false);
            globalScope = getGlobalScope();
            if (globalScope && globalScope.document && globalScope.document.hasFocus()) {
              this.initialize(true);
            }
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.setSessionId = function (sessionId, deviceId) {
    return returnWrapper(this.asyncSetSessionId(sessionId, deviceId));
  };
  SessionReplay.prototype.asyncSetSessionId = function (sessionId, deviceId) {
    return __awaiter$1(this, void 0, void 0, function () {
      var previousSessionId, deviceIdForReplayId, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            previousSessionId = this.identifiers && this.identifiers.sessionId;
            if (previousSessionId) {
              this.stopRecordingAndSendEvents(previousSessionId);
            }
            deviceIdForReplayId = deviceId || this.getDeviceId();
            this.identifiers = new SessionIdentifiers({
              sessionId: sessionId,
              deviceId: deviceIdForReplayId
            });
            if (!(this.joinedConfigGenerator && previousSessionId)) return [3 /*break*/, 2];
            _a = this;
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)];
          case 1:
            _a.config = _b.sent();
            _b.label = 2;
          case 2:
            this.recordEvents();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.getSessionReplayDebugPropertyValue = function () {
    var apiKeyHash = '';
    if (this.config) {
      apiKeyHash = generateHashCode(this.config.apiKey).toString();
    }
    return JSON.stringify({
      appHash: apiKeyHash
    });
  };
  SessionReplay.prototype.getSessionReplayProperties = function () {
    var _a;
    if (!this.config || !this.identifiers) {
      this.loggerProvider.error('Session replay init has not been called, cannot get session recording properties.');
      return {};
    }
    // If the user is in debug mode, ignore the focus handler when tagging events.
    // this is a common mishap when someone is developing locally and not seeing events getting tagged.
    var ignoreFocus = !!this.config.debugMode;
    var shouldRecord = this.getShouldRecord(ignoreFocus);
    if (shouldRecord) {
      var eventProperties = (_a = {}, _a[DEFAULT_SESSION_REPLAY_PROPERTY] = this.identifiers.sessionReplayId ? this.identifiers.sessionReplayId : null, _a);
      if (this.config.debugMode) {
        eventProperties[SESSION_REPLAY_DEBUG_PROPERTY] = this.getSessionReplayDebugPropertyValue();
      }
      return eventProperties;
    }
    return {};
  };
  SessionReplay.prototype.stopRecordingAndSendEvents = function (sessionId) {
    var _a;
    this.stopRecordingEvents();
    var sessionIdToSend = sessionId || ((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId);
    var deviceId = this.getDeviceId();
    this.eventsManager && sessionIdToSend && deviceId && this.eventsManager.sendCurrentSequenceEvents({
      sessionId: sessionIdToSend,
      deviceId: deviceId
    });
  };
  SessionReplay.prototype.initialize = function (shouldSendStoredEvents) {
    var _a;
    if (shouldSendStoredEvents === void 0) {
      shouldSendStoredEvents = false;
    }
    if (!((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId)) {
      this.loggerProvider.log("Session is not being recorded due to lack of session id.");
      return;
    }
    var deviceId = this.getDeviceId();
    if (!deviceId) {
      this.loggerProvider.log("Session is not being recorded due to lack of device id.");
      return;
    }
    this.eventsManager && shouldSendStoredEvents && this.eventsManager.sendStoredEvents({
      deviceId: deviceId
    });
    this.recordEvents();
  };
  SessionReplay.prototype.shouldOptOut = function () {
    var _a, _b;
    var identityStoreOptOut;
    if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
      var identityStore = getAnalyticsConnector(this.config.instanceName).identityStore;
      identityStoreOptOut = identityStore.getIdentity().optOut;
    }
    return identityStoreOptOut !== undefined ? identityStoreOptOut : (_b = this.config) === null || _b === void 0 ? void 0 : _b.optOut;
  };
  SessionReplay.prototype.getShouldRecord = function (ignoreFocus) {
    if (ignoreFocus === void 0) {
      ignoreFocus = false;
    }
    if (!this.identifiers || !this.config || !this.identifiers.sessionId) {
      this.loggerProvider.warn("Session is not being recorded due to lack of config, please call sessionReplay.init.");
      return false;
    }
    if (!this.config.captureEnabled) {
      this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured due to capture being disabled for project."));
      return false;
    }
    var globalScope = getGlobalScope();
    if (!ignoreFocus && globalScope && globalScope.document && !globalScope.document.hasFocus()) {
      this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " temporarily not recording due to lack of browser focus."));
      return false;
    }
    if (this.shouldOptOut()) {
      this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to optOut config."));
      return false;
    }
    var isInSample = isSessionInSample(this.identifiers.sessionId, this.config.sampleRate);
    if (!isInSample) {
      this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to sample rate."));
    }
    return isInSample;
  };
  SessionReplay.prototype.getBlockSelectors = function () {
    var _a, _b, _c;
    // For some reason, this defaults to empty array ([]) if undefined in the compiled script.
    // Empty arrays cause errors when being evaluated in Safari.
    // Force the selector to be undefined if it's an empty array.
    var blockSelector = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.blockSelector) !== null && _c !== void 0 ? _c : [];
    if (blockSelector.length === 0) {
      return undefined;
    }
    return blockSelector;
  };
  SessionReplay.prototype.getMaskTextSelectors = function () {
    var _a, _b, _c, _d;
    if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.defaultMaskLevel) === 'conservative') {
      return '*';
    }
    var maskSelector = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.privacyConfig) === null || _d === void 0 ? void 0 : _d.maskSelector;
    if (!maskSelector) {
      return;
    }
    return maskSelector;
  };
  SessionReplay.prototype.recordEvents = function () {
    var _this = this;
    var _a;
    var shouldRecord = this.getShouldRecord();
    var sessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
    if (!shouldRecord || !sessionId || !this.config) {
      return;
    }
    this.stopRecordingEvents();
    var privacyConfig = this.config.privacyConfig;
    this.recordCancelCallback = record({
      emit: function (event) {
        var globalScope = getGlobalScope();
        if (globalScope && globalScope.document && !globalScope.document.hasFocus() || !_this.getShouldRecord()) {
          _this.stopRecordingAndSendEvents();
          return;
        }
        var eventString = JSON.stringify(event);
        var deviceId = _this.getDeviceId();
        _this.eventsManager && deviceId && _this.eventsManager.addEvent({
          event: {
            type: 'replay',
            data: eventString
          },
          sessionId: sessionId,
          deviceId: deviceId
        });
      },
      packFn: pack,
      inlineStylesheet: this.config.shouldInlineStylesheet,
      hooks: {
        mouseInteraction: this.eventsManager && clickHook({
          eventsManager: this.eventsManager,
          sessionId: sessionId,
          deviceIdFn: this.getDeviceId.bind(this)
        }),
        scroll: this.scrollHook
      },
      maskAllInputs: true,
      maskTextClass: MASK_TEXT_CLASS,
      blockClass: BLOCK_CLASS,
      // rrweb only exposes string type through its types, but arrays are also be supported. #class, ['#class', 'id']
      blockSelector: this.getBlockSelectors(),
      maskInputFn: maskFn('input', privacyConfig),
      maskTextFn: maskFn('text', privacyConfig),
      // rrweb only exposes string type through its types, but arrays are also be supported. since rrweb uses .matches() which supports arrays.
      maskTextSelector: this.getMaskTextSelectors(),
      recordCanvas: false,
      errorHandler: function (error) {
        var typedError = error;
        // styled-components relies on this error being thrown and bubbled up, rrweb is otherwise suppressing it
        if (typedError.message.includes('insertRule') && typedError.message.includes('CSSStyleSheet')) {
          throw typedError;
        }
        // rrweb does monkey patching on certain window functions such as CSSStyleSheet.proptype.insertRule,
        // and errors from external clients calling these functions can get suppressed. Styled components depend
        // on these errors being re-thrown.
        if (typedError._external_) {
          throw typedError;
        }
        _this.loggerProvider.warn('Error while recording: ', typedError.toString());
        // Return true so that we don't clutter user's consoles with internal rrweb errors
        return true;
      }
    });
  };
  SessionReplay.prototype.getDeviceId = function () {
    var _a, _b;
    var identityStoreDeviceId;
    if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
      var identityStore = getAnalyticsConnector(this.config.instanceName).identityStore;
      identityStoreDeviceId = identityStore.getIdentity().deviceId;
    }
    return identityStoreDeviceId || ((_b = this.identifiers) === null || _b === void 0 ? void 0 : _b.deviceId);
  };
  SessionReplay.prototype.getSessionId = function () {
    var _a;
    return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
  };
  SessionReplay.prototype.flush = function (useRetry) {
    var _a;
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter$1(this, void 0, void 0, function () {
      return __generator(this, function (_b) {
        return [2 /*return*/, (_a = this.eventsManager) === null || _a === void 0 ? void 0 : _a.flush(useRetry)];
      });
    });
  };
  SessionReplay.prototype.shutdown = function () {
    this.teardownEventListeners(true);
    this.stopRecordingAndSendEvents();
  };
  return SessionReplay;
}();
var getLogConfig = function getLogConfig(sessionReplay) {
  return function () {
    var config = sessionReplay.config;
    var _a = config || getDefaultConfig(),
      logger = _a.loggerProvider,
      logLevel = _a.logLevel;
    return {
      logger: logger,
      logLevel: logLevel
    };
  };
};
var createInstance = function createInstance() {
  var sessionReplay = new SessionReplay();
  return {
    init: debugWrapper(sessionReplay.init.bind(sessionReplay), 'init', getLogConfig(sessionReplay)),
    setSessionId: debugWrapper(sessionReplay.setSessionId.bind(sessionReplay), 'setSessionId', getLogConfig(sessionReplay)),
    getSessionId: debugWrapper(sessionReplay.getSessionId.bind(sessionReplay), 'getSessionId', getLogConfig(sessionReplay)),
    getSessionReplayProperties: debugWrapper(sessionReplay.getSessionReplayProperties.bind(sessionReplay), 'getSessionReplayProperties', getLogConfig(sessionReplay)),
    flush: debugWrapper(sessionReplay.flush.bind(sessionReplay), 'flush', getLogConfig(sessionReplay)),
    shutdown: debugWrapper(sessionReplay.shutdown.bind(sessionReplay), 'shutdown', getLogConfig(sessionReplay))
  };
};
var sessionReplay = createInstance();
var init = sessionReplay.init,
  setSessionId = sessionReplay.setSessionId,
  getSessionId = sessionReplay.getSessionId,
  getSessionReplayProperties = sessionReplay.getSessionReplayProperties,
  flush = sessionReplay.flush,
  shutdown = sessionReplay.shutdown;
export { flush, getSessionId, getSessionReplayProperties, init, setSessionId, shutdown };